<!-- Console Banco Plaza - Débito Inmediato -->
<div class="min-h-screen bg-gray-50 py-8">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

    <!-- Header -->
    <div class="bg-white rounded-lg shadow-sm border mb-8">
      <div class="px-6 py-4 border-b border-gray-200">
        <div class="flex items-center space-x-4">
          <div class="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center">
            <i class="fas fa-university text-white text-xl"></i>
          </div>
          <div>
            <h1 class="text-2xl font-bold text-gray-900">Banco Plaza - Débito Inmediato</h1>
            <p class="text-sm text-gray-500">Gestión de transacciones y configuración</p>
          </div>
        </div>
      </div>

      <!-- Pestañas -->
      <div class="px-6 bg-gray-50 border-b border-gray-200">
        <nav class="flex space-x-8">
          <button
            (click)="setActiveTab('historial')"
            [class.border-blue-500]="activeTab === 'historial'"
            [class.text-blue-600]="activeTab === 'historial'"
            [class.border-transparent]="activeTab !== 'historial'"
            [class.text-gray-500]="activeTab !== 'historial'"
            class="py-4 px-1 border-b-2 font-medium text-sm hover:text-blue-600 hover:border-blue-300 transition-colors">
            <i class="fas fa-history mr-2"></i>
            Historial
          </button>
          <button
            (click)="setActiveTab('stuck')"
            [class.border-blue-500]="activeTab === 'stuck'"
            [class.text-blue-600]="activeTab === 'stuck'"
            [class.border-transparent]="activeTab !== 'stuck'"
            [class.text-gray-500]="activeTab !== 'stuck'"
            class="py-4 px-1 border-b-2 font-medium text-sm hover:text-blue-600 hover:border-blue-300 transition-colors">
            <i class="fas fa-clock mr-2"></i>
            En cola
          </button>
          <button
            (click)="setActiveTab('configuracion')"
            [class.border-blue-500]="activeTab === 'configuracion'"
            [class.text-blue-600]="activeTab === 'configuracion'"
            [class.border-transparent]="activeTab !== 'configuracion'"
            [class.text-gray-500]="activeTab !== 'configuracion'"
            class="py-4 px-1 border-b-2 font-medium text-sm hover:text-blue-600 hover:border-blue-300 transition-colors">
            <i class="fas fa-cog mr-2"></i>
            Configuración
          </button>
        </nav>
      </div>
    </div>

    <div *ngIf="activeTab === 'stuck'">

      <div class="bg-white rounded-lg shadow-sm border mb-6">
        <div class="px-6 py-4 border-b border-gray-200">
          <div class="flex items-center justify-between">
            <h2 class="text-lg font-semibold text-gray-900 flex items-center">
              <i class="fas fa-clock text-blue-500 mr-2"></i>
              Transacciones en cola
            </h2>
            <div class="flex items-center gap-2">
              <button
                *ngIf="activeStuckSubTab === 'queued'"
                (click)="loadQueuedTransactions()"
                [disabled]="loadingQueuedTransactions"
                class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                <i class="fas fa-sync-alt mr-2"></i>
                Refrescar
              </button>
              <button
                *ngIf="activeStuckSubTab === 'unverified'"
                (click)="loadStuckTransactions()"
                [disabled]="verifyingStuckTransactions || loadingStuckTransactions"
                class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                <i class="fas fa-sync-alt mr-2"></i>
                Refrescar
              </button>
            </div>
          </div>
        </div>
        <div class="px-6 py-4">
          <div class="flex items-center justify-between">
            <p class="text-sm text-gray-600">
              {{ activeStuckSubTab === 'queued'
                  ? 'Se muestran transacciones en estado PROCESSING actualmente encoladas para verificación automática.'
                  : 'Se muestran transacciones en estado PROCESSING con respuesta de verificación registrada, pero sin marca de encolado.' }}
            </p>
          </div>
        </div>

        <div class="px-6 bg-gray-50 border-t border-gray-200">
          <nav class="flex space-x-8">
            <button
              (click)="setActiveStuckSubTab('queued')"
              [class.border-blue-500]="activeStuckSubTab === 'queued'"
              [class.text-blue-600]="activeStuckSubTab === 'queued'"
              [class.border-transparent]="activeStuckSubTab !== 'queued'"
              [class.text-gray-500]="activeStuckSubTab !== 'queued'"
              class="py-3 px-1 border-b-2 font-medium text-sm hover:text-blue-600 hover:border-blue-300 transition-colors">
              <i class="fas fa-list mr-2"></i>
              Encoladas
            </button>
            <button
              (click)="setActiveStuckSubTab('unverified')"
              [class.border-blue-500]="activeStuckSubTab === 'unverified'"
              [class.text-blue-600]="activeStuckSubTab === 'unverified'"
              [class.border-transparent]="activeStuckSubTab !== 'unverified'"
              [class.text-gray-500]="activeStuckSubTab !== 'unverified'"
              class="py-3 px-1 border-b-2 font-medium text-sm hover:text-blue-600 hover:border-blue-300 transition-colors">
              <i class="fas fa-check-circle mr-2"></i>
              Completadas Manuales
              <span *ngIf="stuckTotalTransactions > 0" class="ml-2 px-2 py-0.5 bg-green-700 text-white text-xs rounded-full">
                {{ stuckTotalTransactions }}
              </span>
            </button>
            <button
              (click)="setActiveStuckSubTab('stuck')"
              [class.border-blue-500]="activeStuckSubTab === 'stuck'"
              [class.text-blue-600]="activeStuckSubTab === 'stuck'"
              [class.border-transparent]="activeStuckSubTab !== 'stuck'"
              [class.text-gray-500]="activeStuckSubTab !== 'stuck'"
              class="py-3 px-1 border-b-2 font-medium text-sm hover:text-blue-600 hover:border-blue-300 transition-colors">
              <i class="fas fa-exclamation-triangle mr-2"></i>
              Atascadas
              <span *ngIf="stuckTransactionsCount > 0" class="ml-2 px-2 py-0.5 bg-yellow-500 text-white text-xs rounded-full">
                {{ stuckTransactionsCount }}
              </span>
            </button>
            <button
              (click)="setActiveStuckSubTab('anomalies')"
              [class.border-blue-500]="activeStuckSubTab === 'anomalies'"
              [class.text-blue-600]="activeStuckSubTab === 'anomalies'"
              [class.border-transparent]="activeStuckSubTab !== 'anomalies'"
              [class.text-gray-500]="activeStuckSubTab !== 'anomalies'"
              class="py-3 px-1 border-b-2 font-medium text-sm hover:text-blue-600 hover:border-blue-300 transition-colors">
              <i class="fas fa-bug mr-2"></i>
              Anomalías
              <span *ngIf="anomaliesSummary?.total > 0" class="ml-2 px-2 py-0.5 bg-red-500 text-white text-xs rounded-full">
                {{ anomaliesSummary.total }}
              </span>
            </button>
          </nav>
        </div>
      </div>

      <!-- Subpestaña: Encoladas -->
      <div *ngIf="activeStuckSubTab === 'queued'">
        <div class="bg-white rounded-lg shadow-sm border">
          <div class="px-6 py-4 border-b border-gray-200">
            <div class="flex items-center justify-between">
              <h3 class="text-lg font-semibold text-gray-900">
                Transacciones ({{ queuedTotalTransactions }})
              </h3>
              <div class="flex items-center space-x-3">
                <button
                  (click)="toggleQueuedSortOrder()"
                  class="px-3 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors flex items-center space-x-2"
                  title="Invertir orden">
                  <i class="fas fa-sort"></i>
                  <span class="text-sm">{{ queuedSortOrder === -1 ? 'Mayor a menor' : 'Menor a mayor' }}</span>
                </button>
                <span class="text-sm text-gray-500">Página {{ queuedCurrentPage }} de {{ queuedTotalPages }}</span>
              </div>
            </div>
          </div>

          <div *ngIf="loadingQueuedTransactions" class="px-6 py-12 text-center">
            <i class="fas fa-spinner fa-spin text-4xl text-blue-500 mb-4"></i>
            <p class="text-gray-600">Cargando transacciones...</p>
          </div>

          <div *ngIf="!loadingQueuedTransactions && queuedTransactions.length === 0" class="px-6 py-12 text-center">
            <i class="fas fa-inbox text-4xl text-gray-300 mb-4"></i>
            <p class="text-gray-600">No se encontraron transacciones</p>
          </div>

          <div *ngIf="!loadingQueuedTransactions && queuedTransactions.length > 0" class="divide-y divide-gray-200">
            <div *ngFor="let tx of queuedTransactions" class="hover:bg-gray-50 transition-colors">
              <div
                (click)="toggleTransaction(tx.transaction_number)"
                class="px-6 py-4 cursor-pointer"
                [class]="getStateClass(tx.state) + ' border-l-4'">
                <div class="flex items-center justify-between">
                  <div class="flex-1">
                    <div class="flex items-center space-x-4">
                      <span class="text-lg font-bold text-gray-900">#{{ tx.transaction_number }}</span>
                      <span class="px-3 py-1 rounded-full text-sm font-bold" [class]="getStateClass(tx.state)">
                        {{ tx.state_label }}
                      </span>
                    </div>
                    <div class="mt-2 flex items-center space-x-6 text-sm text-gray-600">
                      <span><i class="fas fa-calendar mr-1"></i>{{ tx.date_created }} {{ tx.time_created }}</span>
                      <span><i class="fas fa-money-bill mr-1"></i>Bs. {{ tx.amount }}</span>
                      <span *ngIf="tx.verification_attempts !== undefined"><i class="fas fa-sync-alt mr-1"></i>Intentos: {{ tx.verification_attempts }}</span>
                      <span *ngIf="tx.person_display" class="max-w-xs truncate">
                        <i class="fas fa-user mr-1"></i>Cliente: {{ tx.person_display }}
                      </span>
                      <span *ngIf="tx.payer_identity" class="max-w-xs truncate">
                        <i class="fas fa-id-card mr-1"></i>Pagador: {{ tx.payer_identity }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <i class="fas" [class.fa-chevron-down]="expandedTransaction !== tx.transaction_number" [class.fa-chevron-up]="expandedTransaction === tx.transaction_number"></i>
                  </div>
                </div>
              </div>

              <div *ngIf="expandedTransaction === tx.transaction_number" class="px-6 py-4 bg-gray-50 border-t border-gray-200">
                <div *ngIf="loadingBitacoras" class="text-center py-8">
                  <i class="fas fa-spinner fa-spin text-2xl text-blue-500 mb-2"></i>
                  <p class="text-sm text-gray-600">Cargando historial...</p>
                </div>

                <div *ngIf="!loadingBitacoras && bitacoras.length > 0" class="space-y-4">
                  <h4 class="text-sm font-semibold text-gray-700 mb-3">Historial de Acciones</h4>

                  <div *ngFor="let bitacora of bitacoras" class="bg-white rounded-lg border border-gray-200 p-4">
                    <div class="flex items-start justify-between mb-3">
                      <div>
                        <h5 class="font-semibold text-gray-900">{{ getActionName(bitacora.endpoint) }}</h5>
                        <p class="text-xs text-gray-500">{{ bitacora.date }} {{ bitacora.time }}</p>
                      </div>
                      <span class="px-2 py-1 rounded text-xs font-medium"
                            [class.bg-green-100]="bitacora.statusResponse === 200"
                            [class.text-green-700]="bitacora.statusResponse === 200"
                            [class.bg-red-100]="bitacora.statusResponse !== 200"
                            [class.text-red-700]="bitacora.statusResponse !== 200">
                        {{ bitacora.statusResponse }}
                      </span>
                    </div>

                    <div class="grid grid-cols-2 gap-4 text-sm">
                      <div>
                        <p class="font-medium text-gray-700 mb-2">Datos enviados:</p>
                        <div class="bg-gray-50 p-3 rounded space-y-1">
                          <div *ngIf="bitacora.requestData.identity" class="flex justify-between">
                            <span class="text-gray-600">Cédula:</span>
                            <span class="font-medium">{{ bitacora.requestData.identity }}</span>
                          </div>
                          <div *ngIf="bitacora.requestData.amount" class="flex justify-between">
                            <span class="text-gray-600">Monto:</span>
                            <span class="font-medium">Bs {{ bitacora.requestData.amount }}</span>
                          </div>
                          <div *ngIf="bitacora.requestData.phone" class="flex justify-between">
                            <span class="text-gray-600">Teléfono:</span>
                            <span class="font-medium">{{ bitacora.requestData.phone }}</span>
                          </div>
                          <div *ngIf="bitacora.requestData.accountNumber" class="flex justify-between">
                            <span class="text-gray-600">Cuenta:</span>
                            <span class="font-medium">{{ bitacora.requestData.accountNumber }}</span>
                          </div>
                          <div *ngIf="bitacora.requestData.accountType" class="flex justify-between">
                            <span class="text-gray-600">Tipo Cuenta:</span>
                            <span class="font-medium">{{ bitacora.requestData.accountType }}</span>
                          </div>
                          <div *ngIf="bitacora.requestData.bankCode" class="flex justify-between">
                            <span class="text-gray-600">Banco:</span>
                            <span class="font-medium">{{ bitacora.requestData.bankCode }}</span>
                          </div>
                          <p *ngIf="!bitacora.requestData || Object.keys(bitacora.requestData).length === 0" class="text-gray-500 text-xs">Sin datos</p>
                        </div>
                      </div>
                      <div>
                        <p class="font-medium text-gray-700 mb-2">Respuesta:</p>
                        <div class="bg-gray-50 p-3 rounded space-y-1">
                          <div *ngIf="bitacora.responseData.message" class="mb-2">
                            <span class="text-gray-600 block mb-1">Mensaje:</span>
                            <span class="font-medium text-sm">{{ bitacora.responseData.message }}</span>
                          </div>
                          
                          <!-- Verification Response (para /verify-payment) -->
                          <div *ngIf="bitacora.responseData.verificationResponse" class="mt-3 pt-3 border-t border-gray-200">
                            <span class="text-gray-700 block mb-2 font-semibold text-sm">Verificación Banco Plaza:</span>
                            <div class="space-y-1">
                              <div *ngIf="bitacora.responseData.verificationResponse.paymentStatus" class="flex justify-between">
                                <span class="text-gray-600 text-xs">Estado:</span>
                                <span class="font-medium text-xs" 
                                      [class.text-green-600]="bitacora.responseData.verificationResponse.paymentStatus === 'APPROVED'"
                                      [class.text-red-600]="bitacora.responseData.verificationResponse.paymentStatus === 'REJECTED'"
                                      [class.text-yellow-600]="bitacora.responseData.verificationResponse.paymentStatus === 'PENDING'">
                                  {{ bitacora.responseData.verificationResponse.paymentStatus }}
                                </span>
                              </div>
                              <div *ngIf="bitacora.responseData.verificationResponse.bankCode" class="flex justify-between">
                                <span class="text-gray-600 text-xs">Código Banco:</span>
                                <span class="font-medium text-xs">{{ bitacora.responseData.verificationResponse.bankCode }}</span>
                              </div>
                              <div *ngIf="bitacora.responseData.verificationResponse.client_description" class="flex justify-between">
                                <span class="text-gray-600 text-xs">Descripción:</span>
                                <span class="font-medium text-xs">{{ bitacora.responseData.verificationResponse.client_description }}</span>
                              </div>
                              <div *ngIf="bitacora.responseData.verificationResponse.verificationDate" class="flex justify-between">
                                <span class="text-gray-600 text-xs">Fecha Verificación:</span>
                                <span class="font-medium text-xs">{{ bitacora.responseData.verificationResponse.verificationDate | date:'dd/MM/yyyy h:mm:ss a' }}</span>
                              </div>
                            </div>
                          </div>
                          
                          <p *ngIf="!bitacora.responseData || Object.keys(bitacora.responseData).length === 0" class="text-gray-500 text-xs">Sin datos</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="!loadingBitacoras && bitacoras.length === 0" class="text-center py-8">
                  <p class="text-sm text-gray-600">No hay historial de acciones</p>
                </div>
              </div>

            </div>
          </div>

          <div *ngIf="!loadingQueuedTransactions && queuedTransactions.length > 0" class="px-6 py-4 border-t border-gray-200 flex items-center justify-between">
            <button
              (click)="changeQueuedPage(queuedCurrentPage - 1)"
              [disabled]="queuedCurrentPage === 1"
              class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
              <i class="fas fa-chevron-left mr-2"></i>
              Anterior
            </button>
            <span class="text-sm text-gray-600">Página {{ queuedCurrentPage }} de {{ queuedTotalPages }}</span>
            <button
              (click)="changeQueuedPage(queuedCurrentPage + 1)"
              [disabled]="queuedCurrentPage === queuedTotalPages"
              class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
              Siguiente
              <i class="fas fa-chevron-right ml-2"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Subpestaña: Sin verificación (stuck actual) -->
      <div *ngIf="activeStuckSubTab === 'unverified'" class="bg-white rounded-lg shadow-sm border">
        <div class="px-6 py-4 border-b border-gray-200">
          <div class="flex items-center justify-between">
            <h3 class="text-lg font-semibold text-gray-900">
              Transacciones ({{ stuckTotalTransactions }})
            </h3>
            <div class="flex items-center space-x-3">
              <button
                (click)="syncManualCompleteStates()"
                [disabled]="syncingManualComplete"
                class="px-3 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
                title="Sincronizar estados según pagos conciliados/anulados">
                <i class="fas fa-sync-alt" [class.fa-spin]="syncingManualComplete"></i>
                <span class="text-sm">{{ syncingManualComplete ? 'Sincronizando...' : 'Sincronizar Estados' }}</span>
              </button>
              <button
                (click)="toggleStuckSortOrder()"
                class="px-3 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors flex items-center space-x-2"
                title="Invertir orden">
                <i class="fas fa-sort"></i>
                <span class="text-sm">{{ stuckSortOrder === -1 ? 'Mayor a menor' : 'Menor a mayor' }}</span>
              </button>
              <span class="text-sm text-gray-500">Página {{ stuckCurrentPage }} de {{ stuckTotalPages }}</span>
            </div>
          </div>
        </div>

        <div *ngIf="loadingStuckTransactions" class="px-6 py-12 text-center">
          <i class="fas fa-spinner fa-spin text-4xl text-blue-500 mb-4"></i>
          <p class="text-gray-600">Cargando transacciones...</p>
        </div>

        <div *ngIf="!loadingStuckTransactions && stuckTransactions.length === 0" class="px-6 py-12 text-center">
          <i class="fas fa-inbox text-4xl text-gray-300 mb-4"></i>
          <p class="text-gray-600">No se encontraron transacciones</p>
        </div>

        <div *ngIf="!loadingStuckTransactions && stuckTransactions.length > 0" class="divide-y divide-gray-200">
          <div *ngFor="let tx of stuckTransactions" class="hover:bg-gray-50 transition-colors">
            <div
              (click)="toggleTransaction(tx.transaction_number)"
              class="px-6 py-4 cursor-pointer"
              [class]="getStateClass(tx.state) + ' border-l-4'">
              <div class="flex items-center justify-between">
                <div class="flex-1">
                  <div class="flex items-center space-x-4">
                    <span class="text-lg font-bold text-gray-900">#{{ tx.transaction_number }}</span>
                    <span class="px-3 py-1 rounded-full text-sm font-bold" [class]="getStateClass(tx.state)">
                      {{ tx.state_label }}
                    </span>
                  </div>
                  <div class="mt-2 flex items-center space-x-6 text-sm text-gray-600">
                    <span><i class="fas fa-calendar mr-1"></i>{{ tx.date_created }} {{ tx.time_created }}</span>
                    <span><i class="fas fa-money-bill mr-1"></i>Bs. {{ tx.amount }}</span>
                    <span *ngIf="tx.verification_attempts !== undefined"><i class="fas fa-sync-alt mr-1"></i>Intentos: {{ tx.verification_attempts }}</span>
                    <span *ngIf="tx.person_display" class="max-w-xs truncate">
                      <i class="fas fa-user mr-1"></i>Cliente: {{ tx.person_display }}
                    </span>
                    <span *ngIf="tx.payer_identity" class="max-w-xs truncate">
                      <i class="fas fa-id-card mr-1"></i>Pagador: {{ tx.payer_identity }}
                    </span>
                  </div>

                  <div class="mt-3 flex items-center space-x-2">
                    <!-- Botón Ver Detalle del Pago (para transacciones con codePayment) -->
                    <button *ngIf="(tx.state === 'COMPLETE' || tx.state === 'MANUAL_COMPLETE' || tx.state === 'FAILED' || tx.state === 'CANCELED') && tx.codePayment" 
                            (click)="openPaymentDetailModal(tx); $event.stopPropagation()"
                            [ngClass]="tx.state === 'FAILED' || tx.state === 'CANCELED' ? 'bg-red-50 hover:bg-red-100 text-red-700 border-red-200' : 'bg-green-50 hover:bg-green-100 text-green-700 border-green-200'"
                            class="text-xs px-3 py-1.5 rounded-lg border transition-colors duration-200 flex items-center space-x-2">
                      <i class="fas fa-receipt"></i>
                      <span>Ver Detalle del Pago</span>
                    </button>
                  </div>
                </div>
                <div class="flex items-center space-x-2">
                  <i class="fas" [class.fa-chevron-down]="expandedTransaction !== tx.transaction_number" [class.fa-chevron-up]="expandedTransaction === tx.transaction_number"></i>
                </div>
              </div>
            </div>

            <div *ngIf="expandedTransaction === tx.transaction_number" class="px-6 py-4 bg-gray-50 border-t border-gray-200">
              <div *ngIf="loadingBitacoras" class="text-center py-8">
                <i class="fas fa-spinner fa-spin text-2xl text-blue-500 mb-2"></i>
                <p class="text-sm text-gray-600">Cargando historial...</p>
              </div>

              <div *ngIf="!loadingBitacoras && bitacoras.length > 0" class="space-y-4">
                <h4 class="text-sm font-semibold text-gray-700 mb-3">Historial de Acciones</h4>

                <div *ngFor="let bitacora of bitacoras" class="bg-white rounded-lg border border-gray-200 p-4">
                  <div class="flex items-start justify-between mb-3">
                    <div>
                      <h5 class="font-semibold text-gray-900">{{ getActionName(bitacora.endpoint) }}</h5>
                      <p class="text-xs text-gray-500">{{ bitacora.date }} {{ bitacora.time }}</p>
                    </div>
                    <span class="px-2 py-1 rounded text-xs font-medium"
                          [class.bg-green-100]="bitacora.statusResponse === 200"
                          [class.text-green-700]="bitacora.statusResponse === 200"
                          [class.bg-red-100]="bitacora.statusResponse !== 200"
                          [class.text-red-700]="bitacora.statusResponse !== 200">
                      {{ bitacora.statusResponse }}
                    </span>
                  </div>

                  <div class="grid grid-cols-2 gap-4 text-sm">
                    <div>
                      <p class="font-medium text-gray-700 mb-2">Datos enviados:</p>
                      <div class="bg-gray-50 p-3 rounded space-y-1">
                        <div *ngIf="bitacora.requestData.identity" class="flex justify-between">
                          <span class="text-gray-600">Cédula:</span>
                          <span class="font-medium">{{ bitacora.requestData.identity }}</span>
                        </div>
                        <div *ngIf="bitacora.requestData.amount" class="flex justify-between">
                          <span class="text-gray-600">Monto:</span>
                          <span class="font-medium">Bs {{ bitacora.requestData.amount }}</span>
                        </div>
                        <div *ngIf="bitacora.requestData.phone" class="flex justify-between">
                          <span class="text-gray-600">Teléfono:</span>
                          <span class="font-medium">{{ bitacora.requestData.phone }}</span>
                        </div>
                        <div *ngIf="bitacora.requestData.accountNumber" class="flex justify-between">
                          <span class="text-gray-600">Cuenta:</span>
                          <span class="font-medium">{{ bitacora.requestData.accountNumber }}</span>
                        </div>
                        <div *ngIf="bitacora.requestData.accountType" class="flex justify-between">
                          <span class="text-gray-600">Tipo Cuenta:</span>
                          <span class="font-medium">{{ bitacora.requestData.accountType }}</span>
                        </div>
                        <div *ngIf="bitacora.requestData.bankCode" class="flex justify-between">
                          <span class="text-gray-600">Banco:</span>
                          <span class="font-medium">{{ bitacora.requestData.bankCode }}</span>
                        </div>
                        <p *ngIf="!bitacora.requestData || Object.keys(bitacora.requestData).length === 0" class="text-gray-500 text-xs">Sin datos</p>
                      </div>
                    </div>
                    <div>
                      <p class="font-medium text-gray-700 mb-2">Respuesta:</p>
                      <div class="bg-gray-50 p-3 rounded space-y-1">
                        <div *ngIf="bitacora.responseData.message" class="mb-2">
                          <span class="text-gray-600 block mb-1">Mensaje:</span>
                          <span class="font-medium text-sm">{{ bitacora.responseData.message }}</span>
                        </div>
                        <div *ngIf="bitacora.responseData.verificationResponse" class="mt-3 pt-3 border-t border-gray-200">
                          <span class="text-gray-700 block mb-2 font-semibold text-sm">Verificación Banco Plaza:</span>
                          <div class="space-y-1">
                            <div *ngIf="bitacora.responseData.verificationResponse.paymentStatus" class="flex justify-between">
                              <span class="text-gray-600 text-xs">Estado:</span>
                              <span class="font-medium text-xs" 
                                    [class.text-green-600]="bitacora.responseData.verificationResponse.paymentStatus === 'APPROVED'"
                                    [class.text-red-600]="bitacora.responseData.verificationResponse.paymentStatus === 'REJECTED'"
                                    [class.text-yellow-600]="bitacora.responseData.verificationResponse.paymentStatus === 'PENDING'">
                                {{ bitacora.responseData.verificationResponse.paymentStatus }}
                              </span>
                            </div>
                            <div *ngIf="bitacora.responseData.verificationResponse.bankCode" class="flex justify-between">
                              <span class="text-gray-600 text-xs">Código Banco:</span>
                              <span class="font-medium text-xs">{{ bitacora.responseData.verificationResponse.bankCode }}</span>
                            </div>
                            <div *ngIf="bitacora.responseData.verificationResponse.client_description" class="flex justify-between">
                              <span class="text-gray-600 text-xs">Descripción:</span>
                              <span class="font-medium text-xs">{{ bitacora.responseData.verificationResponse.client_description }}</span>
                            </div>
                            <div *ngIf="bitacora.responseData.verificationResponse.verificationDate" class="flex justify-between">
                              <span class="text-gray-600 text-xs">Fecha Verificación:</span>
                              <span class="font-medium text-xs">{{ bitacora.responseData.verificationResponse.verificationDate | date:'dd/MM/yyyy h:mm:ss a' }}</span>
                            </div>
                          </div>
                        </div>
                        <p *ngIf="!bitacora.responseData || Object.keys(bitacora.responseData).length === 0" class="text-gray-500 text-xs">Sin datos</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="!loadingBitacoras && bitacoras.length === 0" class="text-center py-8">
                <p class="text-sm text-gray-600">No hay historial de acciones</p>
              </div>
            </div>

          </div>
        </div>

        <div *ngIf="!loadingStuckTransactions && stuckTransactions.length > 0" class="px-6 py-4 border-t border-gray-200 flex items-center justify-between">
          <button
            (click)="changeStuckPage(stuckCurrentPage - 1)"
            [disabled]="stuckCurrentPage === 1"
            class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
            <i class="fas fa-chevron-left mr-2"></i>
            Anterior
          </button>
          <span class="text-sm text-gray-600">Página {{ stuckCurrentPage }} de {{ stuckTotalPages }}</span>
          <button
            (click)="changeStuckPage(stuckCurrentPage + 1)"
            [disabled]="stuckCurrentPage === stuckTotalPages"
            class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
            Siguiente
            <i class="fas fa-chevron-right ml-2"></i>
          </button>
        </div>
      </div>

      <!-- Subpestaña: Atascadas -->
      <div *ngIf="activeStuckSubTab === 'stuck'" class="bg-white rounded-lg shadow-sm border">
        <div class="px-6 py-4 border-b border-gray-200">
          <div class="flex items-center justify-between">
            <div>
              <h3 class="text-lg font-semibold text-gray-900">
                Transacciones Atascadas ({{ stuckTransactionsCount }})
              </h3>
              <p class="text-sm text-gray-600 mt-2">
                Transacciones en estado PROCESSING que salieron de la cola de verificación sin completarse
              </p>
            </div>
            <div class="flex items-center space-x-2">
              <button
                (click)="verifyStuckTransactions()"
                [disabled]="verifyingStuckTransactions || loadingStuckTransactionsList"
                class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                <i class="fas fa-sync-alt mr-2" [class.fa-spin]="verifyingStuckTransactions"></i>
                {{ verifyingStuckTransactions ? 'Verificando...' : 'Verificación Masiva' }}
              </button>
              <button
                (click)="toggleStuckTransactionsSortOrder()"
                class="px-3 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors flex items-center space-x-2"
                title="Invertir orden">
                <i class="fas fa-sort"></i>
                <span class="text-sm">{{ stuckTransactionsSortOrder === -1 ? 'Mayor a menor' : 'Menor a mayor' }}</span>
              </button>
              <span class="text-sm text-gray-500">Página {{ stuckTransactionsPage }} de {{ stuckTransactionsTotalPages }}</span>
            </div>
          </div>
        </div>

        <div *ngIf="loadingStuckTransactionsList" class="px-6 py-12 text-center">
          <i class="fas fa-spinner fa-spin text-4xl text-blue-500 mb-4"></i>
          <p class="text-gray-600">Cargando transacciones atascadas...</p>
        </div>

        <div *ngIf="!loadingStuckTransactionsList && stuckTransactionsList.length === 0" class="px-6 py-12 text-center">
          <i class="fas fa-inbox text-4xl text-gray-300 mb-4"></i>
          <p class="text-gray-600">No se encontraron transacciones atascadas</p>
        </div>

        <div *ngIf="!loadingStuckTransactionsList && stuckTransactionsList.length > 0" class="divide-y divide-gray-200">
          <div *ngFor="let tx of stuckTransactionsList" class="hover:bg-gray-50 transition-colors">
            <div
              (click)="toggleTransaction(tx.transaction_number)"
              class="px-6 py-4 cursor-pointer"
              [class]="getStateClass(tx.state) + ' border-l-4'">
              <div class="flex items-center justify-between">
                <div class="flex-1">
                  <div class="flex items-center space-x-4">
                    <span class="text-lg font-bold text-gray-900">#{{ tx.transaction_number }}</span>
                    <span class="px-3 py-1 rounded-full text-sm font-bold" [class]="getStateClass(tx.state)">
                      {{ tx.state_label }}
                    </span>
                  </div>
                  <div class="mt-2 flex items-center space-x-6 text-sm text-gray-600">
                    <span><i class="fas fa-calendar mr-1"></i>{{ tx.date_created }} {{ tx.time_created }}</span>
                    <span><i class="fas fa-money-bill mr-1"></i>Bs. {{ tx.amount }}</span>
                    <span *ngIf="tx.verification_attempts !== undefined"><i class="fas fa-sync-alt mr-1"></i>Intentos: {{ tx.verification_attempts }}</span>
                    <span *ngIf="tx.person_display" class="max-w-xs truncate">
                      <i class="fas fa-user mr-1"></i>Cliente: {{ tx.person_display }}
                    </span>
                    <span *ngIf="tx.payer_identity" class="max-w-xs truncate">
                      <i class="fas fa-id-card mr-1"></i>Pagador: {{ tx.payer_identity }}
                    </span>
                  </div>

                  <div class="mt-3 flex items-center space-x-2">
                    <!-- Botón Verificar -->
                    <button (click)="verifyPayment(tx); $event.stopPropagation()"
                            class="text-xs bg-blue-50 hover:bg-blue-100 text-blue-700 px-3 py-1.5 rounded-lg border border-blue-200 transition-colors duration-200 flex items-center space-x-2">
                      <i class="fas fa-search"></i>
                      <span>Verificar</span>
                    </button>
                    
                    <!-- Botón Liberar de Cola -->
                    <button *ngIf="tx.verification_queued" 
                            (click)="releaseFromQueue(tx.transaction_number, false); $event.stopPropagation()"
                            class="text-xs bg-amber-50 hover:bg-amber-100 text-amber-700 px-3 py-1.5 rounded-lg border border-amber-200 transition-colors duration-200 flex items-center space-x-2">
                      <i class="fas fa-unlock"></i>
                      <span>Liberar de Cola</span>
                    </button>
                    
                    <!-- Botón Marcar para Verificación Manual -->
                    <button *ngIf="!tx.codePayment" 
                            (click)="releaseFromQueue(tx.transaction_number, true); $event.stopPropagation()"
                            class="text-xs bg-green-50 hover:bg-green-100 text-green-700 px-3 py-1.5 rounded-lg border border-green-200 transition-colors duration-200 flex items-center space-x-2"
                            title="Marcar transacción para verificación manual. El pago ya está creado y por conciliar. Verificar con Banco Plaza si el débito fue procesado.">
                      <i class="fas fa-user-check"></i>
                      <span>Verificación Manual</span>
                    </button>
                    
                    <!-- Botón Cancelar Transacción -->
                    <button (click)="cancelTransaction(tx); $event.stopPropagation()"
                            class="text-xs bg-red-50 hover:bg-red-100 text-red-700 px-3 py-1.5 rounded-lg border border-red-200 transition-colors duration-200 flex items-center space-x-2">
                      <i class="fas fa-times-circle"></i>
                      <span>Cancelar Transacción</span>
                    </button>
                  </div>
                </div>
                <div class="flex items-center space-x-2">
                  <i class="fas" [class.fa-chevron-down]="expandedTransaction !== tx.transaction_number" [class.fa-chevron-up]="expandedTransaction === tx.transaction_number"></i>
                </div>
              </div>
            </div>

            <div *ngIf="expandedTransaction === tx.transaction_number" class="px-6 py-4 bg-gray-50 border-t border-gray-200">
              <div *ngIf="loadingBitacoras" class="text-center py-8">
                <i class="fas fa-spinner fa-spin text-2xl text-blue-500 mb-2"></i>
                <p class="text-sm text-gray-600">Cargando historial...</p>
              </div>

              <div *ngIf="!loadingBitacoras && bitacoras.length > 0" class="space-y-4">
                <h4 class="text-sm font-semibold text-gray-700 mb-3">Historial de Acciones</h4>

                <div *ngFor="let bitacora of bitacoras" class="bg-white rounded-lg border border-gray-200 p-4">
                  <div class="flex items-start justify-between mb-3">
                    <div>
                      <h5 class="font-semibold text-gray-900">{{ getActionName(bitacora.endpoint) }}</h5>
                      <p class="text-xs text-gray-500">{{ bitacora.date }} {{ bitacora.time }}</p>
                    </div>
                    <span class="px-2 py-1 rounded text-xs font-medium"
                          [class.bg-green-100]="bitacora.statusResponse === 200"
                          [class.text-green-700]="bitacora.statusResponse === 200"
                          [class.bg-red-100]="bitacora.statusResponse !== 200"
                          [class.text-red-700]="bitacora.statusResponse !== 200">
                      {{ bitacora.statusResponse }}
                    </span>
                  </div>

                  <div class="grid grid-cols-2 gap-4 text-sm">
                    <div>
                      <p class="font-medium text-gray-700 mb-2">Datos enviados:</p>
                      <div class="bg-gray-50 p-3 rounded space-y-1">
                        <div *ngIf="bitacora.requestData.identity" class="flex justify-between">
                          <span class="text-gray-600">Cédula:</span>
                          <span class="font-medium">{{ bitacora.requestData.identity }}</span>
                        </div>
                        <div *ngIf="bitacora.requestData.amount" class="flex justify-between">
                          <span class="text-gray-600">Monto:</span>
                          <span class="font-medium">Bs {{ bitacora.requestData.amount }}</span>
                        </div>
                        <div *ngIf="bitacora.requestData.phone" class="flex justify-between">
                          <span class="text-gray-600">Teléfono:</span>
                          <span class="font-medium">{{ bitacora.requestData.phone }}</span>
                        </div>
                        <div *ngIf="bitacora.requestData.account_number" class="flex justify-between">
                          <span class="text-gray-600">Cuenta:</span>
                          <span class="font-medium">{{ bitacora.requestData.account_number }}</span>
                        </div>
                        <p *ngIf="!bitacora.requestData || Object.keys(bitacora.requestData).length === 0" class="text-gray-500 text-xs">Sin datos</p>
                      </div>
                    </div>

                    <div>
                      <p class="font-medium text-gray-700 mb-2">Respuesta recibida:</p>
                      <div class="bg-gray-50 p-3 rounded space-y-1">
                        <div *ngIf="bitacora.responseData.verificationResponse" class="space-y-1">
                          <div class="bg-blue-50 p-2 rounded mb-2">
                            <p class="text-xs font-semibold text-blue-700 mb-1">Respuesta de Verificación</p>
                            <div *ngIf="bitacora.responseData.verificationResponse.status" class="flex justify-between">
                              <span class="text-gray-600 text-xs">Estado:</span>
                              <span class="font-medium text-xs">{{ bitacora.responseData.verificationResponse.status }}</span>
                            </div>
                            <div *ngIf="bitacora.responseData.verificationResponse.client_description" class="flex justify-between">
                              <span class="text-gray-600 text-xs">Descripción:</span>
                              <span class="font-medium text-xs">{{ bitacora.responseData.verificationResponse.client_description }}</span>
                            </div>
                            <div *ngIf="bitacora.responseData.verificationResponse.verificationDate" class="flex justify-between">
                              <span class="text-gray-600 text-xs">Fecha Verificación:</span>
                              <span class="font-medium text-xs">{{ bitacora.responseData.verificationResponse.verificationDate | date:'dd/MM/yyyy h:mm:ss a' }}</span>
                            </div>
                          </div>
                        </div>
                        <p *ngIf="!bitacora.responseData || Object.keys(bitacora.responseData).length === 0" class="text-gray-500 text-xs">Sin datos</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="!loadingBitacoras && bitacoras.length === 0" class="text-center py-8">
                <p class="text-sm text-gray-600">No hay historial de acciones</p>
              </div>
            </div>

          </div>
        </div>

        <div *ngIf="!loadingStuckTransactionsList && stuckTransactionsList.length > 0" class="px-6 py-4 border-t border-gray-200 flex items-center justify-between">
          <button
            (click)="changeStuckTransactionsPage(stuckTransactionsPage - 1)"
            [disabled]="stuckTransactionsPage === 1"
            class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
            <i class="fas fa-chevron-left mr-2"></i>
            Anterior
          </button>
          <span class="text-sm text-gray-600">Página {{ stuckTransactionsPage }} de {{ stuckTransactionsTotalPages }}</span>
          <button
            (click)="changeStuckTransactionsPage(stuckTransactionsPage + 1)"
            [disabled]="stuckTransactionsPage === stuckTransactionsTotalPages"
            class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
            Siguiente
            <i class="fas fa-chevron-right ml-2"></i>
          </button>
        </div>
      </div>

      <!-- Subpestaña: Anomalías -->
      <div *ngIf="activeStuckSubTab === 'anomalies'" class="bg-white rounded-lg shadow-sm border">
        <div class="px-6 py-4 border-b border-gray-200">
          <div class="flex items-center justify-between">
            <div>
              <h3 class="text-lg font-semibold text-gray-900">Transacciones con Anomalías</h3>
              <p class="text-sm text-gray-600 mt-1">Transacciones con posibles errores que requieren atención</p>
            </div>
            <div class="flex items-center space-x-2">
              <button
                (click)="loadAnomalies()"
                [disabled]="loadingAnomalies"
                class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
                <i class="fas fa-sync-alt mr-2"></i>
                Refrescar
              </button>
              <button
                (click)="toggleAnomaliesSortOrder()"
                class="px-3 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors flex items-center space-x-2"
                title="Invertir orden">
                <i class="fas fa-sort"></i>
                <span class="text-sm">{{ anomaliesSortOrder === -1 ? 'Mayor a menor' : 'Menor a mayor' }}</span>
              </button>
            </div>
          </div>

          <!-- Resumen de anomalías -->
          <div *ngIf="anomaliesSummary" class="mt-4 grid grid-cols-3 gap-4">
            <div class="bg-red-50 border border-red-200 rounded-lg p-4">
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm text-red-600 font-medium">Críticas</p>
                  <p class="text-2xl font-bold text-red-700">{{ anomaliesSummary.bySeverity.critical }}</p>
                  <p class="text-xs text-red-600 mt-1">PROCESSING sin verificación</p>
                </div>
                <i class="fas fa-exclamation-circle text-3xl text-red-400"></i>
              </div>
            </div>
            <div class="bg-orange-50 border border-orange-200 rounded-lg p-4">
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm text-orange-600 font-medium">Altas</p>
                  <p class="text-2xl font-bold text-orange-700">{{ anomaliesSummary.bySeverity.high }}</p>
                  <p class="text-xs text-orange-600 mt-1">Intentos excedidos</p>
                </div>
                <i class="fas fa-exclamation-triangle text-3xl text-orange-400"></i>
              </div>
            </div>
            <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <div class="flex items-center justify-between">
                <div>
                  <p class="text-sm text-blue-600 font-medium">Total</p>
                  <p class="text-2xl font-bold text-blue-700">{{ anomaliesSummary.total }}</p>
                  <p class="text-xs text-blue-600 mt-1">Anomalías detectadas</p>
                </div>
                <i class="fas fa-bug text-3xl text-blue-400"></i>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="loadingAnomalies" class="px-6 py-12 text-center">
          <i class="fas fa-spinner fa-spin text-4xl text-blue-500 mb-4"></i>
          <p class="text-gray-600">Cargando anomalías...</p>
        </div>

        <div *ngIf="!loadingAnomalies && anomalies.length === 0" class="px-6 py-12 text-center">
          <i class="fas fa-check-circle text-4xl text-green-500 mb-4"></i>
          <p class="text-gray-600">No se detectaron anomalías</p>
        </div>

        <div *ngIf="!loadingAnomalies && anomalies.length > 0">
          <div class="overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Transacción</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cliente</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cédula</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Monto</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estado</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Anomalía</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Fecha</th>
                  <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr *ngFor="let anomaly of anomalies" class="hover:bg-gray-50">
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="text-sm font-medium text-gray-900">#{{ anomaly.transaction_number }}</div>
                  </td>
                  <td class="px-6 py-4">
                    <div class="text-sm text-gray-900">
                      {{ (anomaly.person_name && anomaly.person_last_name) ? (anomaly.person_name + ' ' + anomaly.person_last_name) : 'N/A' }}
                    </div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="text-sm text-gray-600">{{ anomaly.person_identity || 'N/A' }}</div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="text-sm font-medium text-gray-900">Bs. {{ anomaly.amount }}</div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <span [ngClass]="getStateClass(anomaly.state)" class="px-2 py-1 text-xs font-semibold rounded-full border">
                      {{ anomaly.state_label }}
                    </span>
                  </td>
                  <td class="px-6 py-4">
                    <span [ngClass]="getSeverityClass(anomaly.severity)" class="px-2 py-1 text-xs font-semibold rounded border inline-block">
                      {{ anomaly.description }}
                    </span>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div class="text-sm text-gray-500">{{ anomaly.date_created | date:'dd/MM/yyyy HH:mm' }}</div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm">
                    <div class="flex gap-2">
                      <button
                        *ngIf="anomaly.anomaly_type === 'PROCESSING_WITHOUT_VERIFICATION'"
                        (click)="verifyPayment(anomaly)"
                        class="px-3 py-1 bg-green-600 text-white rounded hover:bg-green-700 transition-colors">
                        <i class="fas fa-check mr-1"></i>
                        Verificar
                      </button>
                      <button
                        (click)="cancelTransaction(anomaly)"
                        class="px-3 py-1 bg-red-600 text-white rounded hover:bg-red-700 transition-colors">
                        <i class="fas fa-times mr-1"></i>
                        Cancelar
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="px-6 py-4 border-t border-gray-200 flex items-center justify-between">
            <button
              (click)="changeAnomaliesPage(anomaliesCurrentPage - 1)"
              [disabled]="anomaliesCurrentPage === 1"
              class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
              <i class="fas fa-chevron-left mr-2"></i>
              Anterior
            </button>
            <span class="text-sm text-gray-600">
              Página {{ anomaliesCurrentPage }} de {{ Math.ceil(anomaliesTotalTransactions / anomaliesLimit) || 1 }}
            </span>
            <button
              (click)="changeAnomaliesPage(anomaliesCurrentPage + 1)"
              [disabled]="anomaliesCurrentPage >= Math.ceil(anomaliesTotalTransactions / anomaliesLimit)"
              class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
              Siguiente
              <i class="fas fa-chevron-right ml-2"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Contenido: Historial -->
    <div *ngIf="activeTab === 'historial'">
      
      <!-- Header con subpestañas -->
      <div class="bg-white rounded-lg shadow-sm border mb-6">
        <div class="px-6 py-4 border-b border-gray-200">
          <h2 class="text-lg font-semibold text-gray-900 flex items-center">
            <i class="fas fa-history text-blue-500 mr-2"></i>
            Historial de Transacciones
          </h2>
        </div>

        <div class="px-6 bg-gray-50 border-b border-gray-200">
          <nav class="flex space-x-8">
            <button
              (click)="setActiveHistorialSubTab('client')"
              [class.border-blue-500]="activeHistorialSubTab === 'client'"
              [class.text-blue-600]="activeHistorialSubTab === 'client'"
              [class.border-transparent]="activeHistorialSubTab !== 'client'"
              [class.text-gray-500]="activeHistorialSubTab !== 'client'"
              class="py-3 px-1 border-b-2 font-medium text-sm hover:text-blue-600 hover:border-blue-300 transition-colors">
              <i class="fas fa-user mr-2"></i>
              Buscar Cliente
            </button>
            <button
              (click)="setActiveHistorialSubTab('payer')"
              [class.border-blue-500]="activeHistorialSubTab === 'payer'"
              [class.text-blue-600]="activeHistorialSubTab === 'payer'"
              [class.border-transparent]="activeHistorialSubTab !== 'payer'"
              [class.text-gray-500]="activeHistorialSubTab !== 'payer'"
              class="py-3 px-1 border-b-2 font-medium text-sm hover:text-blue-600 hover:border-blue-300 transition-colors">
              <i class="fas fa-id-card mr-2"></i>
              Buscar Cédula Pagador
            </button>
            <button
              (click)="setActiveHistorialSubTab('transaction')"
              [class.border-blue-500]="activeHistorialSubTab === 'transaction'"
              [class.text-blue-600]="activeHistorialSubTab === 'transaction'"
              [class.border-transparent]="activeHistorialSubTab !== 'transaction'"
              [class.text-gray-500]="activeHistorialSubTab !== 'transaction'"
              class="py-3 px-1 border-b-2 font-medium text-sm hover:text-blue-600 hover:border-blue-300 transition-colors">
              <i class="fas fa-hashtag mr-2"></i>
              Buscar Transacción
            </button>
          </nav>
        </div>
      </div>

      <!-- Subpestaña: Buscar Cliente -->
      <div *ngIf="activeHistorialSubTab === 'client'">
        <!-- Búsqueda de Cliente -->
        <div class="bg-white rounded-lg shadow-sm border mb-6">
          <div class="px-6 py-4 border-b border-gray-200">
            <h3 class="text-md font-semibold text-gray-900 flex items-center">
              <i class="fas fa-search text-blue-500 mr-2"></i>
              Buscar por Cédula
            </h3>
          </div>
        <div class="px-6 py-4">
          <div class="flex gap-4">
            <div class="flex-1">
              <label class="block text-sm font-medium text-gray-700 mb-2">Cédula</label>
              <input
                type="text"
                [(ngModel)]="clientIdentity"
                (keyup.enter)="searchClient()"
                placeholder="Ej: 19820976"
                class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
            </div>
            <div class="flex items-end gap-2">
              <button
                (click)="searchClient()"
                [disabled]="loadingClient"
                class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 transition-colors">
                <i class="fas fa-search mr-2"></i>
                {{ loadingClient ? 'Buscando...' : 'Buscar' }}
              </button>
              <button
                *ngIf="clientData"
                (click)="clearSearch()"
                class="px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors">
                <i class="fas fa-times mr-2"></i>
                Limpiar
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Header Sticky del Cliente -->
      <div *ngIf="clientData" class="sticky top-0 z-20 bg-white border-b border-gray-200 shadow-sm mb-6 rounded-lg">
        <div class="px-6 py-3">
          <div class="flex items-center space-x-4">
            <div class="w-16 h-16 rounded-full overflow-hidden border-2 border-blue-600 flex items-center justify-center bg-gray-100">
              <img *ngIf="clientData?.person?.file_selfie?.url"
                   [src]="sanitize(clientData.person.file_selfie.url)"
                   alt="Foto del cliente"
                   class="w-full h-full object-cover">
              <img *ngIf="!clientData?.person?.file_selfie?.url && clientData?.person?.gender !== 'F'"
                   [src]="sanitize('../assets/public/images/avatar.png')"
                   alt="Avatar"
                   class="w-full h-full object-cover">
              <img *ngIf="!clientData?.person?.file_selfie?.url && clientData?.person?.gender === 'F'"
                   [src]="sanitize('../assets/public/images/avatara-female.png')"
                   alt="Avatar"
                   class="w-full h-full object-cover">
            </div>
            <div>
              <h2 class="text-lg font-bold text-gray-900 capitalize">
                {{ clientData?.person?.name }} {{ clientData?.person?.lastName }}
              </h2>
              <p class="text-sm text-gray-600">
                <i class="fas fa-id-card mr-1"></i>{{ getIdentity() }}
              </p>
              <p class="text-sm text-gray-600">
                <i class="fas fa-phone mr-1"></i>{{ getContact() }}
              </p>
              <p class="text-sm text-gray-600">
                <i class="fas fa-envelope mr-1"></i>{{ getEmailContact() }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Filtros y Transacciones -->
      <div *ngIf="clientData">
        
        <!-- Filtros -->
        <div class="bg-white rounded-lg shadow-sm border mb-6">
          <div class="px-6 py-4 border-b border-gray-200">
            <h3 class="text-lg font-semibold text-gray-900">Filtros</h3>
          </div>
          <div class="px-6 py-4">
            <div class="grid grid-cols-3 gap-4 mb-6">
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">Fecha Inicial</label>
                <input
                  type="date"
                  [(ngModel)]="filters.dateInitial"
                  class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">Fecha Final</label>
                <input
                  type="date"
                  [(ngModel)]="filters.dateFinal"
                  class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">Estado</label>
                <select
                  [(ngModel)]="filters.state"
                  class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">Todos los estados</option>
                  <option value="PENDING">Pendiente</option>
                  <option value="TOKEN_GENERATED">Token Enviado</option>
                  <option value="PROCESSING">Procesando Pago</option>
                  <option value="COMPLETE">Completado</option>
                  <option value="MANUAL_COMPLETE">Completado Manual</option>
                  <option value="FAILED">Fallido</option>
                  <option value="CANCELED">Cancelado</option>
                </select>
              </div>
            </div>

            <div class="flex gap-3">
              <button
                (click)="applyFilters()"
                class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                <i class="fas fa-filter mr-2"></i>
                Aplicar Filtros
              </button>
              <button
                (click)="clearFilters()"
                class="px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors">
                <i class="fas fa-eraser mr-2"></i>
                Limpiar
              </button>
            </div>
          </div>
        </div>

        <!-- Lista de Transacciones -->
        <div class="bg-white rounded-lg shadow-sm border">
          <div class="px-6 py-4 border-b border-gray-200">
            <div class="flex items-center justify-between">
              <h3 class="text-lg font-semibold text-gray-900">
                Transacciones ({{ totalTransactions }})
              </h3>
              <div class="flex items-center space-x-3">
                <button
                  (click)="toggleSortOrder()"
                  class="px-3 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors flex items-center space-x-2"
                  title="Invertir orden">
                  <i class="fas fa-sort"></i>
                  <span class="text-sm">{{ sortOrder === -1 ? 'Mayor a menor' : 'Menor a mayor' }}</span>
                </button>
                <span class="text-sm text-gray-500">Página {{ currentPage }} de {{ totalPages }}</span>
              </div>
            </div>
          </div>

          <!-- Loading -->
          <div *ngIf="loadingTransactions" class="px-6 py-12 text-center">
            <i class="fas fa-spinner fa-spin text-4xl text-blue-500 mb-4"></i>
            <p class="text-gray-600">Cargando transacciones...</p>
          </div>

          <!-- Sin transacciones -->
          <div *ngIf="!loadingTransactions && transactions.length === 0" class="px-6 py-12 text-center">
            <i class="fas fa-inbox text-4xl text-gray-300 mb-4"></i>
            <p class="text-gray-600">No se encontraron transacciones</p>
          </div>

          <!-- Transacciones -->
          <div *ngIf="!loadingTransactions && transactions.length > 0" class="divide-y divide-gray-200">
            <div *ngFor="let tx of transactions" class="hover:bg-gray-50 transition-colors">
              
              <!-- Fila de transacción -->
              <div
                (click)="toggleTransaction(tx.transaction_number)"
                class="px-6 py-4 cursor-pointer"
                [class]="getStateClass(tx.state) + ' border-l-4'">
                <div class="flex items-center justify-between">
                  <div class="flex-1">
                    <div class="flex items-center space-x-4">
                      <span class="text-lg font-bold text-gray-900">#{{ tx.transaction_number }}</span>
                      <span class="px-3 py-1 rounded-full text-sm font-bold" [class]="getStateClass(tx.state)">
                        {{ tx.state_label }}
                      </span>
                    </div>
                    <div class="mt-2 flex items-center space-x-6 text-sm text-gray-600">
                      <span><i class="fas fa-calendar mr-1"></i>{{ tx.date_created }} {{ tx.time_created }}</span>
                      <span><i class="fas fa-money-bill mr-1"></i>Bs. {{ tx.amount }}</span>
                      <span *ngIf="tx.verification_attempts !== undefined"><i class="fas fa-sync-alt mr-1"></i>Intentos: {{ tx.verification_attempts }}</span>
                      <span *ngIf="tx.validation_type === 'T'"><i class="fas fa-mobile mr-1"></i>{{ tx.phone }}</span>
                      <span *ngIf="tx.validation_type === 'C'"><i class="fas fa-university mr-1"></i>{{ tx.account_number }}</span>
                    </div>
                    
                    <!-- Botones de acción según estado -->
                    <div class="mt-3 flex items-center space-x-2">
                      <!-- Botón Verificar Pago (solo para PROCESSING) -->
                      <button *ngIf="tx.state === 'PROCESSING'" 
                              (click)="verifyPayment(tx)"
                              class="text-xs bg-purple-50 hover:bg-purple-100 text-purple-700 px-3 py-1.5 rounded-lg border border-purple-200 transition-colors duration-200 flex items-center space-x-2">
                        <i class="fas fa-sync-alt"></i>
                        <span>Verificar Pago</span>
                      </button>

                      <!-- Botón Completar Manualmente (para PROCESSING, TOKEN_GENERATED o FAILED con timeout en cualquier bitácora) -->
                      <!-- Excluir si timeout fue en start-payment y nunca intentó ingresar token (token_attempts === 0) -->
                      <button *ngIf="(tx.state === 'PROCESSING' || tx.state === 'TOKEN_GENERATED' || tx.state === 'FAILED') && tx.last_bitacora_has_timeout && !(tx.timeout_endpoint === '/start-payment' && tx.token_attempts === 0)" 
                              (click)="completeTimeoutTransaction(tx.transaction_number)"
                              class="text-xs bg-orange-50 hover:bg-orange-100 text-orange-700 px-3 py-1.5 rounded-lg border border-orange-200 transition-colors duration-200 flex items-center space-x-2">
                        <i class="fas fa-clock"></i>
                        <span>Completar Manualmente (Timeout)</span>
                      </button>
                      
                      <!-- Botón Ver Detalle del Pago (para transacciones con codePayment) -->
                      <button *ngIf="(tx.state === 'COMPLETE' || tx.state === 'MANUAL_COMPLETE' || tx.state === 'FAILED' || tx.state === 'CANCELED') && tx.codePayment" 
                              (click)="openPaymentDetailModal(tx)"
                              [ngClass]="tx.state === 'FAILED' || tx.state === 'CANCELED' ? 'bg-red-50 hover:bg-red-100 text-red-700 border-red-200' : 'bg-green-50 hover:bg-green-100 text-green-700 border-green-200'"
                              class="text-xs px-3 py-1.5 rounded-lg border transition-colors duration-200 flex items-center space-x-2">
                        <i class="fas fa-receipt"></i>
                        <span>Ver Detalle del Pago</span>
                      </button>
                    </div>
                  </div>
                  <div>
                    <i class="fas" [class.fa-chevron-down]="expandedTransaction !== tx.transaction_number" [class.fa-chevron-up]="expandedTransaction === tx.transaction_number"></i>
                  </div>
                </div>
              </div>

              <!-- Bitácoras expandidas -->
              <div *ngIf="expandedTransaction === tx.transaction_number" class="px-6 py-4 bg-gray-50 border-t border-gray-200">
                
                <!-- Loading bitácoras -->
                <div *ngIf="loadingBitacoras" class="text-center py-8">
                  <i class="fas fa-spinner fa-spin text-2xl text-blue-500 mb-2"></i>
                  <p class="text-sm text-gray-600">Cargando historial...</p>
                </div>

                <!-- Bitácoras -->
                <div *ngIf="!loadingBitacoras && bitacoras.length > 0" class="space-y-4">
                  <h4 class="text-sm font-semibold text-gray-700 mb-3">Historial de Acciones</h4>
                  
                  <div *ngFor="let bitacora of bitacoras" class="bg-white rounded-lg border border-gray-200 p-4">
                    <div class="flex items-start justify-between mb-3">
                      <div>
                        <h5 class="font-semibold text-gray-900">{{ getActionName(bitacora.endpoint) }}</h5>
                        <p class="text-xs text-gray-500">{{ bitacora.date }} {{ bitacora.time }}</p>
                      </div>
                      <span class="px-2 py-1 rounded text-xs font-medium"
                            [class.bg-green-100]="bitacora.statusResponse === 200"
                            [class.text-green-700]="bitacora.statusResponse === 200"
                            [class.bg-red-100]="bitacora.statusResponse !== 200"
                            [class.text-red-700]="bitacora.statusResponse !== 200">
                        {{ bitacora.statusResponse }}
                      </span>
                    </div>
                    
                    <div class="grid grid-cols-2 gap-4 text-sm">
                      <div>
                        <p class="font-medium text-gray-700 mb-2">Datos enviados:</p>
                        <div class="bg-gray-50 p-3 rounded space-y-1">
                          <div *ngIf="bitacora.requestData.identity" class="flex justify-between">
                            <span class="text-gray-600">Cédula:</span>
                            <span class="font-medium">{{ bitacora.requestData.identity }}</span>
                          </div>
                          <div *ngIf="bitacora.requestData.amount" class="flex justify-between">
                            <span class="text-gray-600">Monto:</span>
                            <span class="font-medium">Bs {{ bitacora.requestData.amount }}</span>
                          </div>
                          <div *ngIf="bitacora.requestData.validationType" class="flex justify-between">
                            <span class="text-gray-600">Tipo:</span>
                            <span class="font-medium">{{ bitacora.requestData.validationType === 'T' ? 'Teléfono' : 'Cuenta' }}</span>
                          </div>
                          <div *ngIf="bitacora.requestData.phone" class="flex justify-between">
                            <span class="text-gray-600">Teléfono:</span>
                            <span class="font-medium">{{ bitacora.requestData.phone }}</span>
                          </div>
                          <div *ngIf="bitacora.requestData.accountNumber" class="flex justify-between">
                            <span class="text-gray-600">Cuenta:</span>
                            <span class="font-medium">{{ bitacora.requestData.accountNumber }}</span>
                          </div>
                          <div *ngIf="bitacora.requestData.accountType" class="flex justify-between">
                            <span class="text-gray-600">Tipo Cuenta:</span>
                            <span class="font-medium">{{ bitacora.requestData.accountType }}</span>
                          </div>
                          <div *ngIf="bitacora.requestData.bankCode" class="flex justify-between">
                            <span class="text-gray-600">Banco:</span>
                            <span class="font-medium">{{ bitacora.requestData.bankCode }}</span>
                          </div>
                          <p *ngIf="!bitacora.requestData || Object.keys(bitacora.requestData).length === 0" class="text-gray-500 text-xs">Sin datos</p>
                        </div>
                      </div>
                      <div>
                        <p class="font-medium text-gray-700 mb-2">Respuesta:</p>
                        <div class="bg-gray-50 p-3 rounded space-y-1">
                          <div *ngIf="bitacora.responseData.error_code" class="mb-2">
                            <span class="text-red-600 block mb-1 font-semibold">Error:</span>
                            <span class="font-medium text-sm text-red-700">{{ bitacora.responseData.error_code }}</span>
                          </div>
                          <div *ngIf="bitacora.responseData.message" class="mb-2">
                            <span class="text-gray-600 block mb-1">Mensaje:</span>
                            <span class="font-medium text-sm">{{ bitacora.responseData.message }}</span>
                          </div>
                          <div *ngIf="bitacora.responseData.token_attempts !== undefined" class="flex justify-between">
                            <span class="text-gray-600">Intentos Token:</span>
                            <span class="font-medium">{{ bitacora.responseData.token_attempts }}</span>
                          </div>
                          <div *ngIf="bitacora.responseData.payment_retries !== undefined" class="flex justify-between">
                            <span class="text-gray-600">Intentos Pago:</span>
                            <span class="font-medium">{{ bitacora.responseData.payment_retries }}</span>
                          </div>
                          
                          <!-- Verification Response (para /verify-payment) -->
                          <div *ngIf="bitacora.responseData.verificationResponse" class="mt-3 pt-3 border-t border-gray-200">
                            <span class="text-gray-700 block mb-2 font-semibold text-sm">Verificación Banco Plaza:</span>
                            <div class="space-y-1">
                              <div *ngIf="bitacora.responseData.verificationResponse.paymentStatus" class="flex justify-between">
                                <span class="text-gray-600 text-xs">Estado:</span>
                                <span class="font-medium text-xs" 
                                      [class.text-green-600]="bitacora.responseData.verificationResponse.paymentStatus === 'APPROVED'"
                                      [class.text-red-600]="bitacora.responseData.verificationResponse.paymentStatus === 'REJECTED'"
                                      [class.text-yellow-600]="bitacora.responseData.verificationResponse.paymentStatus === 'PENDING'">
                                  {{ bitacora.responseData.verificationResponse.paymentStatus }}
                                </span>
                              </div>
                              <div *ngIf="bitacora.responseData.verificationResponse.bankCode" class="flex justify-between">
                                <span class="text-gray-600 text-xs">Código Banco:</span>
                                <span class="font-medium text-xs">{{ bitacora.responseData.verificationResponse.bankCode }}</span>
                              </div>
                              <div *ngIf="bitacora.responseData.verificationResponse.client_description" class="flex justify-between">
                                <span class="text-gray-600 text-xs">Descripción:</span>
                                <span class="font-medium text-xs">{{ bitacora.responseData.verificationResponse.client_description }}</span>
                              </div>
                              <div *ngIf="bitacora.responseData.verificationResponse.verificationDate" class="flex justify-between">
                                <span class="text-gray-600 text-xs">Fecha Verificación:</span>
                                <span class="font-medium text-xs">{{ bitacora.responseData.verificationResponse.verificationDate | date:'dd/MM/yyyy h:mm:ss a' }}</span>
                              </div>
                            </div>
                          </div>
                          
                          <p *ngIf="!bitacora.responseData || Object.keys(bitacora.responseData).length === 0" class="text-gray-500 text-xs">Sin datos</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Sin bitácoras -->
                <div *ngIf="!loadingBitacoras && bitacoras.length === 0" class="text-center py-8">
                  <p class="text-sm text-gray-600">No hay historial de acciones</p>
                </div>
              </div>

            </div>
          </div>

          <!-- Paginación -->
          <div *ngIf="!loadingTransactions && transactions.length > 0" class="px-6 py-4 border-t border-gray-200 flex items-center justify-between">
            <button
              (click)="changePage(currentPage - 1)"
              [disabled]="currentPage === 1"
              class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
              <i class="fas fa-chevron-left mr-2"></i>
              Anterior
            </button>
            <span class="text-sm text-gray-600">Página {{ currentPage }} de {{ totalPages }}</span>
            <button
              (click)="changePage(currentPage + 1)"
              [disabled]="currentPage === totalPages"
              class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
              Siguiente
              <i class="fas fa-chevron-right ml-2"></i>
            </button>
          </div>
        </div>

      </div>
      </div>

      <!-- Subpestaña: Buscar Cédula Pagador -->
      <div *ngIf="activeHistorialSubTab === 'payer'">
        <!-- Búsqueda por Cédula del Pagador -->
        <div class="bg-white rounded-lg shadow-sm border mb-6">
          <div class="px-6 py-4 border-b border-gray-200">
            <h3 class="text-md font-semibold text-gray-900 flex items-center">
              <i class="fas fa-search text-blue-500 mr-2"></i>
              Buscar por Cédula del Pagador
            </h3>
          </div>
          <div class="px-6 py-4">
            <div class="flex gap-4">
              <div class="flex-1">
                <label class="block text-sm font-medium text-gray-700 mb-2">Cédula del Pagador</label>
                <input
                  type="text"
                  [(ngModel)]="payerIdentity"
                  (keyup.enter)="searchPayerTransactions()"
                  placeholder="Ej: 19820976"
                  class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
              </div>
              <div class="flex items-end gap-2">
                <button
                  (click)="searchPayerTransactions()"
                  [disabled]="loadingPayerTransactions"
                  class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 transition-colors">
                  <i class="fas fa-search mr-2"></i>
                  {{ loadingPayerTransactions ? 'Buscando...' : 'Buscar' }}
                </button>
                <button
                  *ngIf="payerTransactions.length > 0"
                  (click)="clearPayerSearch()"
                  class="px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors">
                  <i class="fas fa-times mr-2"></i>
                  Limpiar
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Filtros y Transacciones -->
        <div *ngIf="payerIdentity && (payerTransactions.length > 0 || loadingPayerTransactions || payerTotalTransactions >= 0)">
          
          <!-- Filtros -->
          <div class="bg-white rounded-lg shadow-sm border mb-6">
            <div class="px-6 py-4 border-b border-gray-200">
              <h3 class="text-lg font-semibold text-gray-900">Filtros</h3>
            </div>
            <div class="px-6 py-4">
              <div class="grid grid-cols-3 gap-4 mb-6">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">Fecha Inicial</label>
                  <input
                    type="date"
                    [(ngModel)]="payerFilters.dateInitial"
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">Fecha Final</label>
                  <input
                    type="date"
                    [(ngModel)]="payerFilters.dateFinal"
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">Estado</label>
                  <select
                    [(ngModel)]="payerFilters.state"
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="">Todos los estados</option>
                    <option value="PENDING">Pendiente</option>
                    <option value="TOKEN_GENERATED">Token Enviado</option>
                    <option value="PROCESSING">Procesando Pago</option>
                    <option value="COMPLETE">Completado</option>
                    <option value="MANUAL_COMPLETE">Completado Manual</option>
                    <option value="FAILED">Fallido</option>
                    <option value="CANCELED">Cancelado</option>
                  </select>
                </div>
              </div>

              <div class="flex gap-3">
                <button
                  (click)="applyPayerFilters()"
                  class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                  <i class="fas fa-filter mr-2"></i>
                  Aplicar Filtros
                </button>
                <button
                  (click)="clearPayerFilters()"
                  class="px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors">
                  <i class="fas fa-eraser mr-2"></i>
                  Limpiar
                </button>
              </div>
            </div>
          </div>

          <!-- Lista de Transacciones -->
          <div class="bg-white rounded-lg shadow-sm border">
            <div class="px-6 py-4 border-b border-gray-200">
              <div class="flex items-center justify-between">
                <h3 class="text-lg font-semibold text-gray-900">
                  Transacciones ({{ payerTotalTransactions }})
                </h3>
                <div class="flex items-center space-x-3">
                  <button
                    (click)="togglePayerSortOrder()"
                    class="px-3 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors flex items-center space-x-2"
                    title="Invertir orden">
                    <i class="fas fa-sort"></i>
                    <span class="text-sm">{{ payerSortOrder === -1 ? 'Mayor a menor' : 'Menor a mayor' }}</span>
                  </button>
                  <span class="text-sm text-gray-500">Página {{ payerCurrentPage }} de {{ payerTotalPages }}</span>
                </div>
              </div>
            </div>

            <!-- Loading -->
            <div *ngIf="loadingPayerTransactions" class="px-6 py-12 text-center">
              <i class="fas fa-spinner fa-spin text-4xl text-blue-500 mb-4"></i>
              <p class="text-gray-600">Cargando transacciones...</p>
            </div>

            <!-- Sin resultados -->
            <div *ngIf="!loadingPayerTransactions && payerTransactions.length === 0" class="px-6 py-12 text-center">
              <i class="fas fa-inbox text-4xl text-gray-300 mb-4"></i>
              <p class="text-gray-600">No se encontraron transacciones para esta cédula</p>
            </div>

            <!-- Transacciones -->
            <div *ngIf="!loadingPayerTransactions && payerTransactions.length > 0" class="divide-y divide-gray-200">
              <div *ngFor="let tx of payerTransactions" class="hover:bg-gray-50 transition-colors">
                <div
                  (click)="toggleTransaction(tx.transaction_number)"
                  class="px-6 py-4 cursor-pointer"
                  [class]="getStateClass(tx.state) + ' border-l-4'">
                  <div class="flex items-center justify-between">
                    <div class="flex-1">
                      <div class="flex items-center space-x-4">
                        <span class="text-lg font-bold text-gray-900">#{{ tx.transaction_number }}</span>
                        <span class="px-3 py-1 rounded-full text-sm font-bold" [class]="getStateClass(tx.state)">
                          {{ tx.state_label }}
                        </span>
                      </div>
                      <div class="mt-2 flex items-center space-x-6 text-sm text-gray-600">
                        <span><i class="fas fa-calendar mr-1"></i>{{ tx.date_created }} {{ tx.time_created }}</span>
                        <span><i class="fas fa-money-bill mr-1"></i>Bs. {{ tx.amount }}</span>
                        <span *ngIf="tx.verification_attempts !== undefined"><i class="fas fa-sync-alt mr-1"></i>Intentos: {{ tx.verification_attempts }}</span>
                        <span *ngIf="tx.person_display" class="max-w-xs truncate">
                          <i class="fas fa-user mr-1"></i>Cliente: {{ tx.person_display }}
                        </span>
                        <span *ngIf="tx.payer_identity" class="max-w-xs truncate">
                          <i class="fas fa-id-card mr-1"></i>Pagador: {{ tx.payer_identity }}
                        </span>
                      </div>

                      <div class="mt-3 flex items-center space-x-2">
                        <!-- Botón Verificar Pago (solo para PROCESSING) -->
                        <button *ngIf="tx.state === 'PROCESSING'" 
                                (click)="verifyPayment(tx); $event.stopPropagation()"
                                class="text-xs bg-purple-50 hover:bg-purple-100 text-purple-700 px-3 py-1.5 rounded-lg border border-purple-200 transition-colors duration-200 flex items-center space-x-2">
                          <i class="fas fa-sync-alt"></i>
                          <span>Verificar Pago</span>
                        </button>

                        <!-- Botón Completar Manualmente (Timeout) -->
                        <!-- Excluir si timeout fue en start-payment y nunca intentó ingresar token (token_attempts === 0) -->
                        <button *ngIf="(tx.state === 'PROCESSING' || tx.state === 'TOKEN_GENERATED' || tx.state === 'FAILED') && tx.last_bitacora_has_timeout && !(tx.timeout_endpoint === '/start-payment' && tx.token_attempts === 0)" 
                                (click)="completeTimeoutTransaction(tx.transaction_number); $event.stopPropagation()"
                                class="text-xs bg-orange-50 hover:bg-orange-100 text-orange-700 px-3 py-1.5 rounded-lg border border-orange-200 transition-colors duration-200 flex items-center space-x-2">
                          <i class="fas fa-clock"></i>
                          <span>Completar Manualmente (Timeout)</span>
                        </button>
                        
                        <!-- Botón Ver Detalle del Pago (para transacciones con codePayment) -->
                        <button *ngIf="(tx.state === 'COMPLETE' || tx.state === 'MANUAL_COMPLETE' || tx.state === 'FAILED' || tx.state === 'CANCELED') && tx.codePayment" 
                                (click)="openPaymentDetailModal(tx); $event.stopPropagation()"
                                [ngClass]="tx.state === 'FAILED' || tx.state === 'CANCELED' ? 'bg-red-50 hover:bg-red-100 text-red-700 border-red-200' : 'bg-green-50 hover:bg-green-100 text-green-700 border-green-200'"
                                class="text-xs px-3 py-1.5 rounded-lg border transition-colors duration-200 flex items-center space-x-2">
                          <i class="fas fa-receipt"></i>
                          <span>Ver Detalle del Pago</span>
                        </button>
                      </div>
                    </div>
                    <div>
                      <i class="fas" [class.fa-chevron-down]="expandedTransaction !== tx.transaction_number" [class.fa-chevron-up]="expandedTransaction === tx.transaction_number"></i>
                    </div>
                  </div>
                </div>

                <!-- Detalles expandidos (bitácoras) -->
                <div *ngIf="expandedTransaction === tx.transaction_number" class="px-6 py-4 bg-gray-50 border-t border-gray-200">
                  <div *ngIf="loadingBitacoras" class="text-center py-8">
                    <i class="fas fa-spinner fa-spin text-2xl text-blue-500 mb-2"></i>
                    <p class="text-sm text-gray-600">Cargando historial...</p>
                  </div>

                  <div *ngIf="!loadingBitacoras && bitacoras.length > 0" class="space-y-4">
                    <h4 class="text-sm font-semibold text-gray-700 mb-3">Historial de Acciones</h4>
                    
                    <div *ngFor="let bitacora of bitacoras" class="bg-white rounded-lg border border-gray-200 p-4">
                      <div class="flex items-start justify-between mb-3">
                        <div>
                          <h5 class="font-semibold text-gray-900">{{ getActionName(bitacora.endpoint) }}</h5>
                          <p class="text-xs text-gray-500">{{ bitacora.date }} {{ bitacora.time }}</p>
                        </div>
                        <span class="px-2 py-1 rounded text-xs font-medium"
                              [class.bg-green-100]="bitacora.statusResponse === 200"
                              [class.text-green-700]="bitacora.statusResponse === 200"
                              [class.bg-red-100]="bitacora.statusResponse !== 200"
                              [class.text-red-700]="bitacora.statusResponse !== 200">
                          {{ bitacora.statusResponse }}
                        </span>
                      </div>
                      
                      <div class="grid grid-cols-2 gap-4 text-sm">
                        <div>
                          <p class="font-medium text-gray-700 mb-2">Datos enviados:</p>
                          <div class="bg-gray-50 p-3 rounded space-y-1">
                            <div *ngIf="bitacora.requestData.identity" class="flex justify-between">
                              <span class="text-gray-600">Cédula:</span>
                              <span class="font-medium">{{ bitacora.requestData.identity }}</span>
                            </div>
                            <div *ngIf="bitacora.requestData.amount" class="flex justify-between">
                              <span class="text-gray-600">Monto:</span>
                              <span class="font-medium">Bs {{ bitacora.requestData.amount }}</span>
                            </div>
                            <p *ngIf="!bitacora.requestData || Object.keys(bitacora.requestData).length === 0" class="text-gray-500 text-xs">Sin datos</p>
                          </div>
                        </div>
                        <div>
                          <p class="font-medium text-gray-700 mb-2">Respuesta:</p>
                          <div class="bg-gray-50 p-3 rounded space-y-1">
                            <div *ngIf="bitacora.responseData.error_code" class="mb-2">
                              <span class="text-red-600 block mb-1 font-semibold">Error:</span>
                              <span class="font-medium text-sm text-red-700">{{ bitacora.responseData.error_code }}</span>
                            </div>
                            <div *ngIf="bitacora.responseData.message" class="mb-2">
                              <span class="text-gray-600 block mb-1">Mensaje:</span>
                              <span class="font-medium text-sm">{{ bitacora.responseData.message }}</span>
                            </div>
                            <div *ngIf="bitacora.responseData.token_attempts !== undefined" class="flex justify-between">
                              <span class="text-gray-600">Intentos Token:</span>
                              <span class="font-medium">{{ bitacora.responseData.token_attempts }}</span>
                            </div>
                            <div *ngIf="bitacora.responseData.payment_retries !== undefined" class="flex justify-between">
                              <span class="text-gray-600">Intentos Pago:</span>
                              <span class="font-medium">{{ bitacora.responseData.payment_retries }}</span>
                            </div>
                            
                            <!-- Verification Response (para /verify-payment) -->
                            <div *ngIf="bitacora.responseData.verificationResponse" class="mt-3 pt-3 border-t border-gray-200">
                              <span class="text-gray-700 block mb-2 font-semibold text-sm">Verificación Banco Plaza:</span>
                              <div class="space-y-1">
                                <div *ngIf="bitacora.responseData.verificationResponse.paymentStatus" class="flex justify-between">
                                  <span class="text-gray-600 text-xs">Estado:</span>
                                  <span class="font-medium text-xs" 
                                        [class.text-green-600]="bitacora.responseData.verificationResponse.paymentStatus === 'APPROVED'"
                                        [class.text-red-600]="bitacora.responseData.verificationResponse.paymentStatus === 'REJECTED'"
                                        [class.text-yellow-600]="bitacora.responseData.verificationResponse.paymentStatus === 'PENDING'">
                                    {{ bitacora.responseData.verificationResponse.paymentStatus }}
                                  </span>
                                </div>
                                <div *ngIf="bitacora.responseData.verificationResponse.bankCode" class="flex justify-between">
                                  <span class="text-gray-600 text-xs">Código Banco:</span>
                                  <span class="font-medium text-xs">{{ bitacora.responseData.verificationResponse.bankCode }}</span>
                                </div>
                                <div *ngIf="bitacora.responseData.verificationResponse.client_description" class="flex justify-between">
                                  <span class="text-gray-600 text-xs">Descripción:</span>
                                  <span class="font-medium text-xs">{{ bitacora.responseData.verificationResponse.client_description }}</span>
                                </div>
                                <div *ngIf="bitacora.responseData.verificationResponse.verificationDate" class="flex justify-between">
                                  <span class="text-gray-600 text-xs">Fecha Verificación:</span>
                                  <span class="font-medium text-xs">{{ bitacora.responseData.verificationResponse.verificationDate | date:'dd/MM/yyyy h:mm:ss a' }}</span>
                                </div>
                              </div>
                            </div>
                            
                            <p *ngIf="!bitacora.responseData || Object.keys(bitacora.responseData).length === 0" class="text-gray-500 text-xs">Sin datos</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="!loadingBitacoras && bitacoras.length === 0" class="text-center py-8">
                    <p class="text-sm text-gray-600">No hay historial de acciones</p>
                  </div>
                </div>

              </div>
            </div>

            <!-- Paginación -->
            <div *ngIf="!loadingPayerTransactions && payerTransactions.length > 0" class="px-6 py-4 border-t border-gray-200 flex items-center justify-between">
              <button
                (click)="changePayerPage(payerCurrentPage - 1)"
                [disabled]="payerCurrentPage === 1"
                class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
                <i class="fas fa-chevron-left mr-2"></i>
                Anterior
              </button>
              <span class="text-sm text-gray-600">Página {{ payerCurrentPage }} de {{ payerTotalPages }}</span>
              <button
                (click)="changePayerPage(payerCurrentPage + 1)"
                [disabled]="payerCurrentPage === payerTotalPages"
                class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
                Siguiente
                <i class="fas fa-chevron-right ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Subpestaña: Buscar Transacción -->
      <div *ngIf="activeHistorialSubTab === 'transaction'">
        <!-- Búsqueda de Transacción -->
        <div class="bg-white rounded-lg shadow-sm border mb-6">
          <div class="px-6 py-4 border-b border-gray-200">
            <h3 class="text-md font-semibold text-gray-900 flex items-center">
              <i class="fas fa-search text-blue-500 mr-2"></i>
              Buscar por Número de Transacción
            </h3>
          </div>
          <div class="px-6 py-4">
            <div class="flex gap-4 mb-4">
              <div class="flex-1">
                <label class="block text-sm font-medium text-gray-700 mb-2">Número de Transacción</label>
                <input
                  type="text"
                  [(ngModel)]="searchTransactionNumber"
                  (keyup.enter)="searchTransactionsByNumber()"
                  placeholder="Ej: 8 (busca 8, 18, 28, 89, 208...)"
                  class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
              </div>
              <div class="flex items-end">
                <button
                  (click)="searchTransactionsByNumber()"
                  [disabled]="loadingSearchTransactions"
                  class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 transition-colors">
                  <i class="fas fa-search mr-2"></i>
                  {{ loadingSearchTransactions ? 'Buscando...' : 'Buscar' }}
                </button>
              </div>
            </div>

            <!-- Filtros adicionales -->
            <div class="grid grid-cols-3 gap-4">
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">Fecha Inicial</label>
                <input
                  type="date"
                  [(ngModel)]="searchFilters.dateInitial"
                  class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">Fecha Final</label>
                <input
                  type="date"
                  [(ngModel)]="searchFilters.dateFinal"
                  class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">Estado</label>
                <select
                  [(ngModel)]="searchFilters.state"
                  class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent">
                  <option value="">Todos</option>
                  <option value="PENDING">Pendiente</option>
                  <option value="TOKEN_GENERATED">Token Enviado</option>
                  <option value="PROCESSING">Procesando</option>
                  <option value="COMPLETE">Completado</option>
                  <option value="MANUAL_COMPLETE">Completado Manual</option>
                  <option value="FAILED">Fallido</option>
                  <option value="CANCELED">Cancelado</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <!-- Resultados de búsqueda -->
        <div *ngIf="searchTransactions.length > 0 || loadingSearchTransactions" class="bg-white rounded-lg shadow-sm border">
          <div class="px-6 py-4 border-b border-gray-200">
            <div class="flex items-center justify-between">
              <h3 class="text-lg font-semibold text-gray-900">
                Resultados ({{ searchTotalTransactions }})
              </h3>
              <div class="flex items-center space-x-3">
                <button
                  (click)="toggleSearchSortOrder()"
                  class="px-3 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors flex items-center space-x-2"
                  title="Invertir orden">
                  <i class="fas fa-sort"></i>
                  <span class="text-sm">{{ searchSortOrder === -1 ? 'Mayor a menor' : 'Menor a mayor' }}</span>
                </button>
                <span class="text-sm text-gray-500">Página {{ searchCurrentPage }} de {{ searchTotalPages }}</span>
              </div>
            </div>
          </div>

          <div *ngIf="loadingSearchTransactions" class="px-6 py-12 text-center">
            <i class="fas fa-spinner fa-spin text-4xl text-blue-500 mb-4"></i>
            <p class="text-gray-600">Buscando transacciones...</p>
          </div>

          <div *ngIf="!loadingSearchTransactions && searchTransactions.length > 0" class="divide-y divide-gray-200">
            <div *ngFor="let tx of searchTransactions" class="hover:bg-gray-50 transition-colors">
              <div
                (click)="toggleTransaction(tx.transaction_number)"
                class="px-6 py-4 cursor-pointer"
                [class]="getStateClass(tx.state) + ' border-l-4'">
                <div class="flex items-center justify-between">
                  <div class="flex-1">
                    <div class="flex items-center space-x-4">
                      <span class="text-lg font-bold text-gray-900">#{{ tx.transaction_number }}</span>
                      <span class="px-3 py-1 rounded-full text-sm font-bold" [class]="getStateClass(tx.state)">
                        {{ tx.state_label }}
                      </span>
                    </div>
                    <div class="mt-2 flex items-center space-x-6 text-sm text-gray-600">
                      <span><i class="fas fa-calendar mr-1"></i>{{ tx.date_created }} {{ tx.time_created }}</span>
                      <span><i class="fas fa-money-bill mr-1"></i>Bs. {{ tx.amount }}</span>
                      <span *ngIf="tx.verification_attempts !== undefined"><i class="fas fa-sync-alt mr-1"></i>Intentos: {{ tx.verification_attempts }}</span>
                      <span *ngIf="tx.person_display" class="max-w-xs truncate">
                        <i class="fas fa-user mr-1"></i>Cliente: {{ tx.person_display }}
                      </span>
                      <span *ngIf="tx.payer_identity" class="max-w-xs truncate">
                        <i class="fas fa-id-card mr-1"></i>Pagador: {{ tx.payer_identity }}
                      </span>
                    </div>

                    <div class="mt-3 flex items-center space-x-2">
                      <button *ngIf="tx.state === 'PROCESSING'"
                              (click)="verifyPayment(tx)"
                              class="text-xs bg-purple-50 hover:bg-purple-100 text-purple-700 px-3 py-1.5 rounded-lg border border-purple-200 transition-colors duration-200 flex items-center space-x-2">
                        <i class="fas fa-sync-alt"></i>
                        <span>Verificar Pago</span>
                      </button>

                      <!-- Botón Completar Manualmente (Timeout) -->
                      <!-- Excluir si timeout fue en start-payment y nunca intentó ingresar token (token_attempts === 0) -->
                      <button *ngIf="(tx.state === 'PROCESSING' || tx.state === 'TOKEN_GENERATED' || tx.state === 'FAILED') && tx.last_bitacora_has_timeout && !(tx.timeout_endpoint === '/start-payment' && tx.token_attempts === 0)" 
                              (click)="completeTimeoutTransaction(tx.transaction_number); $event.stopPropagation()"
                              class="text-xs bg-orange-50 hover:bg-orange-100 text-orange-700 px-3 py-1.5 rounded-lg border border-orange-200 transition-colors duration-200 flex items-center space-x-2">
                        <i class="fas fa-clock"></i>
                        <span>Completar Manualmente (Timeout)</span>
                      </button>

                      <!-- Botón Ver Detalle del Pago (para transacciones con codePayment) -->
                      <button *ngIf="(tx.state === 'COMPLETE' || tx.state === 'MANUAL_COMPLETE' || tx.state === 'FAILED' || tx.state === 'CANCELED') && tx.codePayment" 
                              (click)="openPaymentDetailModal(tx)"
                              [ngClass]="tx.state === 'FAILED' || tx.state === 'CANCELED' ? 'bg-red-50 hover:bg-red-100 text-red-700 border-red-200' : 'bg-green-50 hover:bg-green-100 text-green-700 border-green-200'"
                              class="text-xs px-3 py-1.5 rounded-lg border transition-colors duration-200 flex items-center space-x-2">
                        <i class="fas fa-receipt"></i>
                        <span>Ver Detalle del Pago</span>
                      </button>
                    </div>
                  </div>
                  <div>
                    <i class="fas" [class.fa-chevron-down]="expandedTransaction !== tx.transaction_number" [class.fa-chevron-up]="expandedTransaction === tx.transaction_number"></i>
                  </div>
                </div>
              </div>

              <div *ngIf="expandedTransaction === tx.transaction_number" class="px-6 py-4 bg-gray-50 border-t border-gray-200">
                <div *ngIf="loadingBitacoras" class="text-center py-8">
                  <i class="fas fa-spinner fa-spin text-2xl text-blue-500 mb-2"></i>
                  <p class="text-sm text-gray-600">Cargando historial...</p>
                </div>

                <div *ngIf="!loadingBitacoras && bitacoras.length > 0" class="space-y-4">
                  <h4 class="text-sm font-semibold text-gray-700 mb-3">Historial de Acciones</h4>

                  <div *ngFor="let bitacora of bitacoras" class="bg-white rounded-lg border border-gray-200 p-4">
                    <div class="flex items-start justify-between mb-3">
                      <div>
                        <h5 class="font-semibold text-gray-900">{{ getActionName(bitacora.endpoint) }}</h5>
                        <p class="text-xs text-gray-500">{{ bitacora.date }} {{ bitacora.time }}</p>
                      </div>
                      <span class="px-2 py-1 rounded text-xs font-medium"
                            [class.bg-green-100]="bitacora.statusResponse === 200"
                            [class.text-green-700]="bitacora.statusResponse === 200"
                            [class.bg-red-100]="bitacora.statusResponse !== 200"
                            [class.text-red-700]="bitacora.statusResponse !== 200">
                        {{ bitacora.statusResponse }}
                      </span>
                    </div>

                    <div class="grid grid-cols-2 gap-4 text-sm">
                      <div>
                        <p class="font-medium text-gray-700 mb-2">Datos enviados:</p>
                        <div class="bg-gray-50 p-3 rounded space-y-1">
                          <div *ngIf="bitacora.requestData.identity" class="flex justify-between">
                            <span class="text-gray-600">Cédula:</span>
                            <span class="font-medium">{{ bitacora.requestData.identity }}</span>
                          </div>
                          <div *ngIf="bitacora.requestData.amount" class="flex justify-between">
                            <span class="text-gray-600">Monto:</span>
                            <span class="font-medium">Bs {{ bitacora.requestData.amount }}</span>
                          </div>
                          <div *ngIf="bitacora.requestData.phone" class="flex justify-between">
                            <span class="text-gray-600">Teléfono:</span>
                            <span class="font-medium">{{ bitacora.requestData.phone }}</span>
                          </div>
                          <div *ngIf="bitacora.requestData.accountNumber" class="flex justify-between">
                            <span class="text-gray-600">Cuenta:</span>
                            <span class="font-medium">{{ bitacora.requestData.accountNumber }}</span>
                          </div>
                          <div *ngIf="bitacora.requestData.accountType" class="flex justify-between">
                            <span class="text-gray-600">Tipo Cuenta:</span>
                            <span class="font-medium">{{ bitacora.requestData.accountType }}</span>
                          </div>
                          <div *ngIf="bitacora.requestData.bankCode" class="flex justify-between">
                            <span class="text-gray-600">Banco:</span>
                            <span class="font-medium">{{ bitacora.requestData.bankCode }}</span>
                          </div>
                          <p *ngIf="!bitacora.requestData || Object.keys(bitacora.requestData).length === 0" class="text-gray-500 text-xs">Sin datos</p>
                        </div>
                      </div>
                      <div>
                        <p class="font-medium text-gray-700 mb-2">Respuesta:</p>
                        <div class="bg-gray-50 p-3 rounded space-y-1">
                          <div *ngIf="bitacora.responseData.message" class="mb-2">
                            <span class="text-gray-600 block mb-1">Mensaje:</span>
                            <span class="font-medium text-sm">{{ bitacora.responseData.message }}</span>
                          </div>
                          
                          <!-- Verification Response (para /verify-payment) -->
                          <div *ngIf="bitacora.responseData.verificationResponse" class="mt-3 pt-3 border-t border-gray-200">
                            <span class="text-gray-700 block mb-2 font-semibold text-sm">Verificación Banco Plaza:</span>
                            <div class="space-y-1">
                              <div *ngIf="bitacora.responseData.verificationResponse.paymentStatus" class="flex justify-between">
                                <span class="text-gray-600 text-xs">Estado:</span>
                                <span class="font-medium text-xs" 
                                      [class.text-green-600]="bitacora.responseData.verificationResponse.paymentStatus === 'APPROVED'"
                                      [class.text-red-600]="bitacora.responseData.verificationResponse.paymentStatus === 'REJECTED'"
                                      [class.text-yellow-600]="bitacora.responseData.verificationResponse.paymentStatus === 'PENDING'">
                                  {{ bitacora.responseData.verificationResponse.paymentStatus }}
                                </span>
                              </div>
                              <div *ngIf="bitacora.responseData.verificationResponse.bankCode" class="flex justify-between">
                                <span class="text-gray-600 text-xs">Código Banco:</span>
                                <span class="font-medium text-xs">{{ bitacora.responseData.verificationResponse.bankCode }}</span>
                              </div>
                              <div *ngIf="bitacora.responseData.verificationResponse.client_description" class="flex justify-between">
                                <span class="text-gray-600 text-xs">Descripción:</span>
                                <span class="font-medium text-xs">{{ bitacora.responseData.verificationResponse.client_description }}</span>
                              </div>
                              <div *ngIf="bitacora.responseData.verificationResponse.verificationDate" class="flex justify-between">
                                <span class="text-gray-600 text-xs">Fecha Verificación:</span>
                                <span class="font-medium text-xs">{{ bitacora.responseData.verificationResponse.verificationDate | date:'dd/MM/yyyy h:mm:ss a' }}</span>
                              </div>
                            </div>
                          </div>
                          
                          <p *ngIf="!bitacora.responseData || Object.keys(bitacora.responseData).length === 0" class="text-gray-500 text-xs">Sin datos</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="!loadingBitacoras && bitacoras.length === 0" class="text-center py-8">
                  <p class="text-sm text-gray-600">No hay historial de acciones</p>
                </div>
              </div>

            </div>
          </div>

          <div *ngIf="!loadingSearchTransactions && searchTransactions.length > 0" class="px-6 py-4 border-t border-gray-200 flex items-center justify-between">
            <button
              (click)="changeSearchPage(searchCurrentPage - 1)"
              [disabled]="searchCurrentPage === 1"
              class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
              <i class="fas fa-chevron-left mr-2"></i>
              Anterior
            </button>
            <span class="text-sm text-gray-600">Página {{ searchCurrentPage }} de {{ searchTotalPages }}</span>
            <button
              (click)="changeSearchPage(searchCurrentPage + 1)"
              [disabled]="searchCurrentPage === searchTotalPages"
              class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed">
              Siguiente
              <i class="fas fa-chevron-right ml-2"></i>
            </button>
          </div>
        </div>
      </div>

    </div>

    <!-- Contenido: Configuración -->
    <div *ngIf="activeTab === 'configuracion'">
      <div class="bg-white rounded-lg shadow-sm border">
        <div class="px-6 py-4 border-b border-gray-200">
          <h2 class="text-lg font-semibold text-gray-900">Configuración Global - Débito Inmediato</h2>
        </div>

        <!-- Loading -->
        <div *ngIf="loadingConfig" class="px-6 py-12 text-center">
          <i class="fas fa-spinner fa-spin text-4xl text-blue-500 mb-4"></i>
          <p class="text-gray-600">Cargando configuración...</p>
        </div>

        <!-- Formulario -->
        <div *ngIf="!loadingConfig" class="px-6 py-6">
          
          <!-- Límites de Reintentos -->
          <div class="mb-8">
            <h3 class="text-md font-semibold text-gray-900 mb-4">Límites de Reintentos</h3>
            
            <div class="space-y-4">
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Máximo de intentos de envío de token
                  <span class="text-gray-500 text-xs">(Reenvíos permitidos antes de cancelar)</span>
                </label>
                <input
                  type="number"
                  [(ngModel)]="configForm.max_token_attempts"
                  min="1"
                  max="10"
                  class="w-full md:w-64 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500">
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Máximo de intentos de ingreso de token
                  <span class="text-gray-500 text-xs">(Intentos de ingresar token antes de cancelar)</span>
                </label>
                <input
                  type="number"
                  [(ngModel)]="configForm.max_payment_retries"
                  min="1"
                  max="10"
                  class="w-full md:w-64 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500">
              </div>
            </div>
          </div>

          <!-- Verificación Automática -->
          <div class="mb-8">
            <h3 class="text-md font-semibold text-gray-900 mb-4">Verificación Automática</h3>
            
            <div class="space-y-4">
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Máximo de intentos de verificación
                  <span class="text-gray-500 text-xs">(Reintentos automáticos cuando el pago está pendiente)</span>
                </label>
                <input
                  type="number"
                  [(ngModel)]="configForm.max_verification_attempts"
                  min="1"
                  max="20"
                  class="w-full md:w-64 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500">
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Tiempo entre verificaciones (segundos)
                  <span class="text-gray-500 text-xs">(Delay entre cada intento de verificación)</span>
                </label>
                <input
                  type="number"
                  [(ngModel)]="configForm.verification_delay_seconds"
                  min="1"
                  max="60"
                  class="w-full md:w-64 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500">
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">
                  Máximo de intentos del cron antes de auto-completar
                  <span class="text-gray-500 text-xs">(Al alcanzar este límite, se crea un pago por conciliar y la transacción pasa a MANUAL_COMPLETE)</span>
                </label>
                <input
                  type="number"
                  [(ngModel)]="configForm.max_cron_verification_attempts"
                  min="10"
                  max="200"
                  class="w-full md:w-64 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500">
              </div>
            </div>
          </div>

          <!-- Última actualización -->
          <div *ngIf="config" class="mb-6 p-4 bg-gray-50 rounded-lg">
            <p class="text-sm text-gray-600">
              <i class="fas fa-info-circle mr-2"></i>
              Última actualización: {{ formatDate(config.last_updated_at) }} por {{ config.last_updated_by }}
            </p>
          </div>

          <!-- Botones -->
          <div class="flex gap-4">
            <button
              (click)="saveConfig()"
              [disabled]="savingConfig"
              class="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 transition-colors">
              <i class="fas fa-save mr-2"></i>
              {{ savingConfig ? 'Guardando...' : 'Guardar Cambios' }}
            </button>
            <button
              (click)="restoreDefaults()"
              class="px-6 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors">
              <i class="fas fa-undo mr-2"></i>
              Restaurar Valores por Defecto
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- Modal de Detalle del Pago -->
<div *ngIf="isPaymentDetailModalOpen" 
     style="position: fixed !important; top: 0 !important; left: 0 !important; right: 0 !important; bottom: 0 !important; z-index: 99999 !important; overflow: hidden !important; background: rgba(0,0,0,0.5) !important; display: block !important;"
     (click)="closePaymentDetailModal()">
  
  <!-- Panel deslizante desde la derecha -->
  <div style="position: absolute !important; top: 0 !important; right: 0 !important; bottom: 0 !important; width: 100% !important; max-width: 48rem !important; background: white !important; box-shadow: -4px 0 16px rgba(0,0,0,0.2) !important; overflow-y: auto !important;"
       (click)="$event.stopPropagation()">
    
    <!-- Header del modal -->
    <div style="position: sticky; top: 0; background: linear-gradient(to right, #2563eb, #1d4ed8); color: white; padding: 1.5rem; box-shadow: 0 2px 8px rgba(0,0,0,0.1); z-index: 10;">
      <div style="display: flex; align-items: center; justify-content: space-between;">
        <div>
          <h3 style="font-size: 1.25rem; font-weight: bold; margin: 0;"><i class="fas fa-receipt" style="margin-right: 0.5rem;"></i>Detalle del Pago</h3>
          <p style="font-size: 0.875rem; margin: 0.25rem 0 0 0; opacity: 0.9;">Información completa de la transacción</p>
        </div>
        <button (click)="closePaymentDetailModal()" 
                style="background: transparent; border: none; color: white; padding: 0.5rem; cursor: pointer; border-radius: 50%;"
                onmouseover="this.style.background='rgba(255,255,255,0.1)'"
                onmouseout="this.style.background='transparent'">
          <i class="fas fa-times" style="font-size: 1.25rem;"></i>
        </button>
      </div>
    </div>

    <!-- Contenido del modal -->
    <div style="padding: 1.5rem; padding-bottom: 6rem;">
      
      <!-- Loading State -->
      <div *ngIf="isLoadingPaymentDetail" style="display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 3rem 0; text-align: center;">
        <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem; margin-bottom: 1rem;">
          <span class="visually-hidden">Cargando...</span>
        </div>
        <p style="color: #6b7280; margin: 0;">Cargando información del pago...</p>
      </div>

      <!-- Payment Detail Content -->
      <div *ngIf="!isLoadingPaymentDetail && selectedPaymentDetail" class="bg-white rounded-lg shadow-sm border p-6">
        
        <!-- Ver Adjunto -->
        <div *ngIf="selectedPaymentDetail.payment?.file" class="mb-4">
          <button (click)="redirectIMG(selectedPaymentDetail.payment?.file?.url)" 
                  class="text-blue-600 hover:text-blue-800 font-medium text-sm flex items-center space-x-1">
            <i class="fas fa-paperclip"></i>
            <span>Ver Adjunto</span>
          </button>
        </div>

        <!-- Grid de información -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          
          <!-- Código -->
          <div>
            <div class="text-sm text-gray-500 mb-1">Código</div>
            <div class="text-sm font-bold text-gray-900">{{ selectedPaymentDetail.payment?.code }}</div>
          </div>

          <!-- Conciliación -->
          <div class="text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">Conciliación</div>
            <div class="text-sm font-bold text-green-600">
              Auto
            </div>
          </div>

          <!-- Monto total -->
          <div>
            <div class="text-sm text-gray-500 mb-1">Monto total</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.amount | currency:'USD':'':'1.2-2' }} USD</div>
          </div>

          <!-- Estatus -->
          <div class="text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">Estatus</div>
            <div>
              <span *ngIf="selectedPaymentDetail.payment?.reconciled_payment && selectedPaymentDetail.payment?.status"
                    class="inline-block bg-green-100 text-green-800 px-3 py-1 rounded-full text-xs font-medium">Aprobado</span>
              <span *ngIf="!selectedPaymentDetail.payment?.reconciled_payment && selectedPaymentDetail.payment?.status"
                    class="inline-block bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-xs font-medium">Por conciliar</span>
              <span *ngIf="!selectedPaymentDetail.payment?.status"
                    class="inline-block bg-red-100 text-red-800 px-3 py-1 rounded-full text-xs font-medium">Anulado</span>
            </div>
          </div>

          <!-- Tasa de cambio -->
          <div>
            <div class="text-sm text-gray-500 mb-1">Tasa de cambio</div>
            <div class="font-bold text-gray-900">USD 1 = BS {{ selectedPaymentDetail.payment?.rate | currency:'USD':'':'1.2-2' }}</div>
          </div>

          <!-- Monto del pago -->
          <div class="text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">Monto del pago</div>
            <div class="font-bold text-gray-900">{{ selectedPaymentDetail.payment?.counterValue | currency:'USD':'':'1.2-2' }} {{ selectedPaymentDetail.payment?.currency?.name }}</div>
          </div>

          <!-- Tipo de producto -->
          <div class="md:col-span-2">
            <div class="text-sm text-gray-500 mb-1">Tipo de producto</div>
            <div class="font-bold">{{ selectedPaymentDetail.payment?.typeProduct || 'CREDIT' }}</div>
          </div>

          <!-- Fecha conciliación / Anulación -->
          <div>
            <div class="text-sm text-gray-500 mb-1">Fecha conciliación / Anulación</div>
            <div class="font-bold text-gray-900" *ngIf="selectedPaymentDetail.payment?.reconciled_payment_date">
              {{ selectedPaymentDetail.payment?.reconciled_payment_date | date:'dd/MM/yyyy h:mm:ss a' }}
            </div>
            <div class="text-gray-500" *ngIf="!selectedPaymentDetail.payment?.reconciled_payment_date">-</div>
          </div>

          <!-- Responsable -->
          <div class="text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">Responsable</div>
            <div class="font-bold text-gray-900 text-sm capitalize">
              {{ selectedPaymentDetail.payment?.reconciled_payment_ejecutive?.name }} {{ selectedPaymentDetail.payment?.reconciled_payment_ejecutive?.lastName }}
              <span *ngIf="!selectedPaymentDetail.payment?.reconciled_payment_ejecutive">-</span>
            </div>
          </div>

          <!-- Motivo de anulación -->
          <div class="md:col-span-2 text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">Motivo de anulación</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.description || '-' }}</div>
          </div>

          <!-- Fecha de reporte -->
          <div>
            <div class="text-sm text-gray-500 mb-1">Fecha de reporte</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.date | date:'dd/MM/yyyy h:mm:ss a' }}</div>
          </div>

          <!-- Canal de reporte -->
          <div class="text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">Canal de reporte</div>
            <div class="font-bold text-gray-900 text-sm capitalize">
              <span *ngIf="selectedPaymentDetail.payment?.creator_api === 'APP' || selectedPaymentDetail.payment?.creator_api === 'CONSOLE' || selectedPaymentDetail.payment?.creator_api === 'CHATBOT'">
                {{ selectedPaymentDetail.payment?.creator_api }} / {{ selectedPaymentDetail.payment?.creator?.name }} {{ selectedPaymentDetail.payment?.creator?.lastName }}
              </span>
              <span *ngIf="!selectedPaymentDetail.payment?.creator_api">-</span>
            </div>
          </div>

          <!-- Fecha de pago -->
          <div>
            <div class="text-sm text-gray-500 mb-1">Fecha de pago</div>
            <div class="text-gray-900 font-bold">
              {{ selectedPaymentDetail.payment?.register_payment_date ? (selectedPaymentDetail.payment?.register_payment_date | date:'dd/MM/yyyy') : (selectedPaymentDetail.payment?.date | date:'dd/MM/yyyy') }}
            </div>
          </div>

          <!-- Responsable edición -->
          <div class="text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">Responsable edición</div>
            <div class="text-gray-900 font-bold capitalize text-sm">
              {{ selectedPaymentDetail.payment?.payment_edit_ejecutive?.name }} {{ selectedPaymentDetail.payment?.payment_edit_ejecutive?.lastName }}
              <span *ngIf="!selectedPaymentDetail.payment?.payment_edit_ejecutive">-</span>
            </div>
          </div>

          <!-- Banco origen -->
          <div>
            <div class="text-sm text-gray-500 mb-1">Banco origen</div>
            <div class="text-gray-900 font-bold">{{ getBankName(selectedPaymentDetail.payment?.bankCode) || '-' }}</div>
          </div>

          <!-- Método de pago -->
          <div class="text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">Método de pago</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.account_payment?.payment_method?.name || '-' }}</div>
          </div>

          <!-- Teléfono de origen -->
          <div>
            <div class="text-sm text-gray-500 mb-1">Teléfono de origen</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.phone || '-' }}</div>
          </div>

          <!-- Número de referencia -->
          <div class="text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">Número de referencia</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.paymentMethodId || '-' }}</div>
          </div>

          <!-- Cuenta origen (Últimos 6) -->
          <div>
            <div class="text-sm text-gray-500 mb-1">Cuenta origen (Últimos 6)</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.account || '-' }}</div>
          </div>

          <!-- Cédula/Rif titular -->
          <div class="text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">Cédula/Rif titular de la Cta.</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.cid != 'V' ? selectedPaymentDetail.payment?.cid : '-' }}</div>
          </div>

          <!-- Banco destino -->
          <div class="md:col-span-2">
            <div class="text-sm text-gray-500 mb-1">Banco destino</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.account_payment?.bank?.name || '-' }}</div>
          </div>

          <!-- Teléfono destino -->
          <div>
            <div class="text-sm text-gray-500 mb-1">Teléfono destino</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.account_payment?.phone || '-' }}</div>
          </div>

          <!-- Cuenta destino -->
          <div class="text-left md:text-right">
            <div class="text-sm text-gray-500 mb-1">Cuenta destino</div>
            <div class="text-gray-900 font-bold">{{ selectedPaymentDetail.payment?.account_payment?.number || '-' }}</div>
          </div>

        </div>

        <!-- Voucher -->
        <div *ngIf="selectedPaymentDetail.payment?.responseAutoConfirm" class="mt-6">
          <div class="font-bold text-gray-600 mb-2">Voucher</div>
          <div *ngIf="selectedPaymentDetail.payment?.responseAutoConfirm?.descripcion"
               class="text-gray-900 font-bold text-xs mb-2">
            {{ selectedPaymentDetail.payment?.responseAutoConfirm?.descripcion }}
          </div>
          <div *ngIf="selectedPaymentDetail.payment?.responseAutoConfirm?.voucher"
               class="border rounded p-3 bg-gray-50">
            <div class="voucher text-gray-900 uppercase text-xs" [innerHTML]="selectedPaymentDetail.payment?.responseAutoConfirm?.voucher"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
